
/* --------------------自动化码头库区--------------------- */
export const auto_port_storage = [
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M49",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M48",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M47",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M46",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M45",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M44",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M43",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M42",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M41",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M40",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0302",
      "mc": "M39",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089691644819896547,
      "shape_Area": 1.2123925888129842e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23597641300012, 36.013458372000059],
          [120.23622636500011, 36.013615733000051],
          [120.23911769300003, 36.010584175000076],
          [120.23886787700008, 36.010426902000063],
          [120.23597641300012, 36.013458372000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 135,
      "bh": "0302",
      "mc": "M38",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.008970197252029237,
      "shape_Area": 1.2124475067160488e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23570009800005, 36.013284526000064],
          [120.23595033400011, 36.013441454000031],
          [120.23884200500004, 36.010409910000078],
          [120.23859215000004, 36.010252594000065],
          [120.23570009800005, 36.013284526000064]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 134,
      "bh": "0302",
      "mc": "M37",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089700952482138913,
      "shape_Area": 1.2127388677729746e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23539715700008, 36.01309395100003],
          [120.23564767200003, 36.013251180000054],
          [120.23853908900003, 36.01021959600007],
          [120.23828947200002, 36.010062394000045],
          [120.23539715700008, 36.01309395100003]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 133,
      "bh": "0302",
      "mc": "M36",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.008969321586435838,
      "shape_Area": 1.2115965822509293e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23512162600002, 36.012920158000043],
          [120.23537110200004, 36.013077629000065],
          [120.23826302500004, 36.010046112000055],
          [120.23801357100001, 36.009888677000049],
          [120.23512162600002, 36.012920158000043]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 132,
      "bh": "0302",
      "mc": "M35",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089688939322280434,
      "shape_Area": 1.2133570258811383e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23481051200008, 36.012723701000027],
          [120.23506030900012, 36.012881762000063],
          [120.23795164100011, 36.009850072000063],
          [120.23770152400004, 36.009692913000038],
          [120.23481051200008, 36.012723701000027]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 131,
      "bh": "0302",
      "mc": "M34",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089673194365299507,
      "shape_Area": 1.2118309698395727e-6
    },
    "geometry": {
      "rings": [
        [
          [120.2345340920001, 36.012550256000054],   // 左上角
          [120.23478427900011, 36.012706981000065],  // 右上角
          [120.23767481200002, 36.009676957000067],  // 右下角
          [120.23742565800001, 36.009518816000025], // 左下角
          [120.2345340920001, 36.012550256000054]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 130,
      "bh": "0302",
      "mc": "M33",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089688811928524508,
      "shape_Area": 1.2119842136842999e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23423180000009, 36.012359768000067],
          [120.23448151800005, 36.012516976000029],
          [120.23737305000009, 36.009485608000034],
          [120.23712312800001, 36.009328316000051],
          [120.23423180000009, 36.012359768000067]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 129,
      "bh": "0302",
      "mc": "M32",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089699819599458608,
      "shape_Area": 1.2147322749306965e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23395513800006, 36.012185811000052],
          [120.23420584400003, 36.012343211000029],
          [120.23709709400009, 36.009311998000044],
          [120.23684659900005, 36.009154592000073],
          [120.23395513800006, 36.012185811000052]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 128,
      "bh": "0302",
      "mc": "M31",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089674830338240114,
      "shape_Area": 1.2127753398191466e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23365348700008, 36.011994389000051],
          [120.23390261000009, 36.012152772000036],
          [120.23679399800005, 36.009121693000054],
          [120.23654420500009, 36.008964103000039],
          [120.23365348700008, 36.011994389000051]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 127,
      "bh": "0302",
      "mc": "M30",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089685733674406444,
      "shape_Area": 1.2124030113081451e-6
    },
    "geometry": {
      "rings": [
        [
          [120.2333767990001, 36.011821162000047],
          [120.23362751700006, 36.011978341000031],
          [120.23651826900004, 36.008947052000053],
          [120.23626848400011, 36.008790268000041],
          [120.2333767990001, 36.011821162000047]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 126,
      "bh": "0302",
      "mc": "M29",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.008970415297375153,
      "shape_Area": 1.2139199550033132e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23569621600006, 36.008867230000078],
          [120.2330650560001, 36.01162559800008],
          [120.23331561100008, 36.011782620000076],
          [120.23620722800001, 36.008751415000063],
          [120.23595691900005, 36.00859390800008],
          [120.23569621600006, 36.008867230000078]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 89,
      "bh": "0302",
      "mc": "M28",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089706922721447552,
      "shape_Area": 1.214197908898415e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23278867800002, 36.011451557000044],
          [120.23303935200011, 36.011609193000027],
          [120.23593079800003, 36.008577374000026],
          [120.23568074500008, 36.00842018600008],
          [120.23278867800002, 36.011451557000044]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 136,
      "bh": "0302",
      "mc": "M27",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089688611545693606,
      "shape_Area": 1.2108364954384158e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23537836300011, 36.008229518000064],
          [120.23521797500007, 36.008397698000067],
          [120.23248723100005, 36.01126097000008],
          [120.23273627100002, 36.011418392000053],
          [120.23561831000006, 36.00839691200008],
          [120.23562829600007, 36.008386444000053],
          [120.23537836300011, 36.008229518000064]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 138,
      "bh": "0302",
      "mc": "M26",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089703354253094694,
      "shape_Area": 1.2130327399096824e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23510217000012, 36.008055600000034],
          [120.23477505200003, 36.00839856500005],
          [120.23221039700002, 36.011087329000077],
          [120.23246034900001, 36.011244429000044],
          [120.23517619600011, 36.008397780000053],
          [120.23535245800008, 36.008213019000038],
          [120.23510217000012, 36.008055600000034]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 139,
      "bh": "0302",
      "mc": "M25",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089694701956242982,
      "shape_Area": 1.2127409160059183e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23479999800008, 36.007864657000027],
          [120.23428985200007, 36.008399514000075],
          [120.23190797600012, 36.010896636000041],
          [120.23215803800008, 36.011053697000079],
          [120.2346907750001, 36.008398730000067],
          [120.23504937400003, 36.008022806000042],
          [120.23479999800008, 36.007864657000027]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 140,
      "bh": "0302",
      "mc": "M24",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089693732161264979,
      "shape_Area": 1.2111855811138677e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23452366900005, 36.007691394000062],
          [120.23384738000004, 36.008400377000044],
          [120.23163204100001, 36.010722698000052],
          [120.23188156600008, 36.010879906000071],
          [120.23424767300003, 36.008399596000061],
          [120.23477373000003, 36.007848120000062],
          [120.23452366900005, 36.007691394000062]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 141,
      "bh": "0302",
      "mc": "M23",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089706429919524863,
      "shape_Area": 1.2139112450084932e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23421214500001, 36.007495148000032],
          [120.2333477630001, 36.008401350000042],
          [120.23132072500005, 36.010526353000046],
          [120.23157053700004, 36.010684280000078],
          [120.23374890000002, 36.008400569000059],
          [120.2344627330001, 36.007652179000047],
          [120.23421214500001, 36.007495148000032]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 142,
      "bh": "0302",
      "mc": "M22",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089698591656490988,
      "shape_Area": 1.2129122185034568e-6
    },
    "geometry": {
      "rings": [
        [
          [120.2339362030001, 36.00732103200005],
          [120.23290505400007, 36.008402211000032],
          [120.23104455900011, 36.010352877000059],
          [120.23129459000006, 36.010509822000074],
          [120.23330602200008, 36.008401431000038],
          [120.23418633000006, 36.007478642000024],
          [120.2339362030001, 36.00732103200005]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 143,
      "bh": "0302",
      "mc": "M21",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089676632575891469,
      "shape_Area": 1.2109834409984898e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23363183400011, 36.007130649000032],
          [120.23241898700007, 36.008403153000074],
          [120.23074206100011, 36.010162478000041],
          [120.23099181300006, 36.010319027000037],
          [120.23281924300011, 36.008402377000039],
          [120.23388244800003, 36.007287209000026],
          [120.23363183400011, 36.007130649000032]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 144,
      "bh": "0302",
      "mc": "M20",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089667466464120743,
      "shape_Area": 1.2107946094214314e-6
    },
    "geometry": {
      "rings": [
        [
          [120.2333566420001, 36.006956067000033],
          [120.2319764020001, 36.008404010000049],
          [120.23046613100007, 36.00998828400003],
          [120.23071698600006, 36.010143413000037],
          [120.23237666200009, 36.00840323500006],
          [120.23360677100004, 36.007113396000079],
          [120.2333566420001, 36.006956067000033]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 145,
      "bh": "0302",
      "mc": "M19",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089675848918887892,
      "shape_Area": 1.2138262725271896e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23041390500009, 36.009954650000054],
          [120.23189190500011, 36.008404173000031],
          [120.23330313400004, 36.00692366800007],
          [120.23305322300007, 36.006766284000037],
          [120.2314907010001, 36.008404948000077],
          [120.23016269300001, 36.009797601000059],
          [120.23041390500009, 36.009954650000054]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 146,
      "bh": "0302",
      "mc": "M18",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089679091256601121,
      "shape_Area": 1.2117813319528239e-6
    },
    "geometry": {
      "rings": [
        [
          [120.23013711100009, 36.009781076000024],
          [120.23144904900005, 36.008405029000073],
          [120.23302752300003, 36.006749339000066],
          [120.23277698900006, 36.00659311000004],
          [120.23104854300004, 36.008405801000038],
          [120.22988661600004, 36.009624299000052],
          [120.23013711100009, 36.009781076000024]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 147,
      "bh": "0302",
      "mc": "M17",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089693866419830338,
      "shape_Area": 1.2149148588617113e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22982478900008, 36.009586145000071],
          [120.23095046900005, 36.008405990000028],
          [120.23271604600006, 36.006554875000063],
          [120.23246540500008, 36.006397122000067],
          [120.23054901600005, 36.00840676200005],
          [120.22957478000001, 36.009428351000054],
          [120.22982478900008, 36.009586145000071]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 148,
      "bh": "0302",
      "mc": "M16",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089704050833390656,
      "shape_Area": 1.212586760518603e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22954977800009, 36.009411014000079],
          [120.23050727100008, 36.008406842000056],
          [120.23244060200011, 36.006379156000037],
          [120.23219055400011, 36.006221537000044],
          [120.2301068590001, 36.008407611000052],
          [120.22929930000009, 36.009254806000058],
          [120.22954977800009, 36.009411014000079]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 149,
      "bh": "0302",
      "mc": "M15",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089697142215020426,
      "shape_Area": 1.212944495694596e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22924621800007, 36.009221766000053],
          [120.23002232300007, 36.008407773000044],
          [120.23213705000001, 36.00618970000005],
          [120.23188771700006, 36.00603183000004],
          [120.22962148000011, 36.008408541000051],
          [120.22899634500004, 36.009064115000058],
          [120.22924621800007, 36.009221766000053]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 150,
      "bh": "0302",
      "mc": "M14",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089703768274639103,
      "shape_Area": 1.2128822948564033e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22897049300002, 36.009047597000063],
          [120.22957966900003, 36.008408621000058],
          [120.23186136800007, 36.006015189000038],
          [120.2316105860001, 36.005859106000059],
          [120.22917867600006, 36.008409388000075],
          [120.2287193730001, 36.008891024000036],
          [120.22897049300002, 36.009047597000063]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 151,
      "bh": "0302",
      "mc": "M13",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089718477920510721,
      "shape_Area": 1.2140190691684297e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22866670500002, 36.00885788000005],
          [120.22909432100005, 36.008409549000078],
          [120.23155832100008, 36.005826059000071],
          [120.23131001000002, 36.005666111000039],
          [120.22869371700006, 36.00841031300007],
          [120.22841749700001, 36.008700022000028],
          [120.22866670500002, 36.00885788000005]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 152,
      "bh": "0302",
      "mc": "M12",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089679511235245205,
      "shape_Area": 1.2110489988626023e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22839186500005, 36.008682742000076],
          [120.22865158500008, 36.008410393000077],
          [120.23128239800008, 36.005651532000059],
          [120.23103368500006, 36.005493725000065],
          [120.22825113200008, 36.008411156000079],
          [120.22814200900007, 36.008525562000045], // 左上
          [120.22839186500005, 36.008682742000076]  // 右上
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 153,
      "bh": "0302",
      "mc": "M11",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089709084023405408,
      "shape_Area": 1.2105863261249262e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22808046900002, 36.008487076000051],
          [120.22815262100005, 36.008411343000034],
          [120.23097133300007, 36.005452600000069],
          [120.23072160100003, 36.005297528000028],
          [120.2278298980001, 36.008329622000076],
          [120.22796053000002, 36.008411709000029],
          [120.22808046900002, 36.008487076000051]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 122,
      "bh": "0302",
      "mc": "M10",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089700371031426092,
      "shape_Area": 1.2125758164951166e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22755411900005, 36.008156134000046],
          [120.22780418000002, 36.008313520000058],
          [120.23069526000006, 36.005281220000029],
          [120.23044555900003, 36.005123950000041],
          [120.22755411900005, 36.008156134000046]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 121,
      "bh": "0302",
      "mc": "M09",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089681889258828168,
      "shape_Area": 1.2120841643192361e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22725128500008, 36.007965639000076],
          [120.22750154700009, 36.008122925000066],
          [120.23039219800012, 36.005091207000078],
          [120.23014212600003, 36.00493457400006],
          [120.22725128500008, 36.007965639000076]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 120,
      "bh": "0302",
      "mc": "M08",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089689080333324681,
      "shape_Area": 1.2110073726211691e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22697555400009, 36.007792065000046],
          [120.22722511500001, 36.007949300000064],
          [120.23011646000009, 36.004916827000045],
          [120.22986627400007, 36.004760419000036],
          [120.22697555400009, 36.007792065000046]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 119,
      "bh": "0302",
      "mc": "M07",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089677721403166183,
      "shape_Area": 1.2123436037691611e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22667341100009, 36.007600335000063],
          [120.22692278600005, 36.007758350000074],
          [120.22981363300005, 36.004726477000077],
          [120.22956363800006, 36.004569365000066],
          [120.22667341100009, 36.007600335000063]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 124,
      "bh": "0302",
      "mc": "M06",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089681247146875653,
      "shape_Area": 1.2147534382446626e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22639627800004, 36.007427129000064],
          [120.22664728200004, 36.007584116000032],
          [120.22953775100007, 36.004553373000078],
          [120.22928634500011, 36.004396589000066],
          [120.22639627800004, 36.007427129000064]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 123,
      "bh": "0302",
      "mc": "M05",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089669532558512913,
      "shape_Area": 1.2089296704998543e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22608586300009, 36.007231511000043],
          [120.22633507000012, 36.007387492000078],
          [120.22922574500001, 36.004356937000068],
          [120.22897703400008, 36.004198716000076],
          [120.22608586300009, 36.007231511000043]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 117,
      "bh": "0302",
      "mc": "M04",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089680786987224818,
      "shape_Area": 1.212055603955785e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22580905700011, 36.007057573000054],
          [120.22605922500009, 36.007214828000031],
          [120.22895002300004, 36.004183051000041],
          [120.22869958800004, 36.004026671000076],
          [120.22580905700011, 36.007057573000054]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 118,
      "bh": "0302",
      "mc": "M03",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089689435298067402,
      "shape_Area": 1.2131121967239651e-6
    },
    "geometry": {
      "rings": [
        [
          [120.2255066460001, 36.006867028000045],
          [120.22575685000004, 36.007024086000058],
          [120.22864802000004, 36.003992696000068],
          [120.22839736500009, 36.003835691000063],
          [120.2255066460001, 36.006867028000045]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 137,
      "bh": "0302",
      "mc": "M02",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0089697222074641616,
      "shape_Area": 1.2121022122062252e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22523031000003, 36.006693340000027],
          [120.22548051000001, 36.006850808000024],
          [120.22837173800008, 36.003818463000073],
          [120.22812192400011, 36.003661830000055],
          [120.22523031000003, 36.006693340000027]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 91,
      "bh": "0302",
      "mc": "M01",
      "lx": "场站",
      "dmgd": 0,
      "ssgs_old": "QQCTN",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0068179332177564448,
      "shape_Area": 9.0206939726733595e-7
    },
    "geometry": {
      "rings": [
        [
          [120.22567033000007, 36.005724465000071],
          [120.22592163200011, 36.005880442000034],
          [120.22806956700003, 36.003628220000053],
          [120.22781909500009, 36.003470640000046],
          [120.22567033000007, 36.005724465000071]
        ]
      ]
    }
  },
]

// 干散货码头库区
export const dry_dock_storage = [
  {
    "attributes": {
      "OBJECTID": 782,
      "bh": "0302",
      "mc": "86,87码头前沿",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.012790072287952151,
      "shape_Area": 3.091566556801466e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22568715900002, 36.031864398000039],
          [120.22559142500006, 36.031912588000068],
          [120.22518611400005, 36.032116600000052],
          [120.22551185200007, 36.032537991000027],
          [120.22552812700008, 36.032529691000036],
          [120.22556531300006, 36.032577797000044],
          [120.22554867000008, 36.032586284000047],
          [120.22555545900002, 36.032594914000072],
          [120.22558203500012, 36.03262869200006],
          [120.22557411300011, 36.032631787000071],
          [120.22557578500005, 36.032631619000028],
          [120.22557728700008, 36.032631690000073],
          [120.22557885500009, 36.032631933000062],
          [120.22558040100012, 36.032632565000029],
          [120.22558206000008, 36.032633502000067],
          [120.22558328400009, 36.03263473700008],
          [120.22558402800007, 36.032635815000049],
          [120.22558462800009, 36.032637326000042],
          [120.22558480400005, 36.032638809000048],
          [120.22558420500002, 36.03264133700003],
          [120.22558302500011, 36.032643050000047],
          [120.22558103200004, 36.032644604000041],
          [120.22557493800002, 36.032647626000028],
          [120.22566031700001, 36.03276124100006],
          [120.22566574900009, 36.032758548000061],
          [120.22566683100001, 36.032757395000033],
          [120.22566840200011, 36.032756396000025],
          [120.22566974200004, 36.032755808000047],
          [120.22567122200007, 36.032755442000052],
          [120.22567289500012, 36.032755273000078],
          [120.22567439700003, 36.032755345000055],
          [120.22567596500005, 36.032755587000054],
          [120.22567751000008, 36.032756220000067],
          [120.22567917000003, 36.032757156000059],
          [120.22568039400005, 36.032758391000073],
          [120.22568113800003, 36.03275947000003],
          [120.22568173800005, 36.032760981000024],
          [120.22568191400001, 36.03276246300004],
          [120.2256813140001, 36.032764991000079],
          [120.22568013400007, 36.032766705000029],
          [120.22567981700001, 36.032766953000078],
          [120.22568631700005, 36.032763580000051],
          [120.2257228630001, 36.032810621000067],
          [120.22634546900008, 36.033612007000045],
          [120.2263375550001, 36.033616111000072],
          [120.22633862900011, 36.033616003000077],
          [120.22634013000004, 36.033616074000065],
          [120.22634169900005, 36.033616317000053],
          [120.22634324400008, 36.033616949000077],
          [120.22634490300004, 36.033617885000069],
          [120.22634612800005, 36.033619121000072],
          [120.22634687200002, 36.03362020000003],
          [120.22634747200004, 36.033621710000034],
          [120.22634764800011, 36.033623193000039],
          [120.22634704800009, 36.033625720000032],
          [120.22634586800007, 36.033627434000039],
          [120.22634387500011, 36.033628988000032],
          [120.22634100500011, 36.033630047000031],
          [120.2263355880001, 36.033632856000054],
          [120.22642736000012, 36.033749595000074],
          [120.22643066100011, 36.03375449400005],
          [120.22643042400011, 36.033752949000075],
          [120.22643073300003, 36.033751657000039],
          [120.22643115000005, 36.033750416000032],
          [120.22643199000004, 36.033749052000076],
          [120.22643307200008, 36.033747900000037],
          [120.22643464400005, 36.033746901000029],
          [120.2264359830001, 36.033746312000062],
          [120.22643746300002, 36.033745947000057],
          [120.22643913600007, 36.033745778000025],
          [120.22644063700011, 36.03374584900007],
          [120.22644220600012, 36.033746092000058],
          [120.22644375100003, 36.033746724000025],
          [120.22644541000011, 36.033747661000064],
          [120.22644663400001, 36.033748896000077],
          [120.22644737900009, 36.033749975000035],
          [120.22644797900011, 36.033751485000039],
          [120.22644815500007, 36.033752968000044],
          [120.22644755500005, 36.033755495000037],
          [120.22644724300005, 36.033755949000067],
          [120.22645057700004, 36.033754169000076],
          [120.22648179500004, 36.033794037000064],
          [120.22648857100012, 36.033802691000062],
          [120.22651506900002, 36.033789462000072],
          [120.22658810900009, 36.033883413000069],
          [120.22656427100003, 36.033895639000036],
          [120.22710381200011, 36.034594197000047],
          [120.2270983300001, 36.034597957000074],
          [120.22709983100003, 36.034598028000062],
          [120.22710140100003, 36.03459827000006],
          [120.22710294600006, 36.034598903000074],
          [120.22710460500002, 36.034599839000066],
          [120.22710582900004, 36.034601074000079],
          [120.22710657400012, 36.034602153000037],
          [120.22710717400003, 36.034603664000031],
          [120.22710734900011, 36.034605147000036],
          [120.22710675000008, 36.034607674000029],
          [120.22710557000005, 36.034609388000035],
          [120.2271035760001, 36.034610942000029],
          [120.22710070700009, 36.034612000000038],
          [120.22709765700006, 36.034612176000053],
          [120.22709270600001, 36.034614708000049],
          [120.22719288400003, 36.034743949000074],
          [120.2271997790001, 36.034740423000073],
          [120.22720086200002, 36.034739270000046],
          [120.22720243400011, 36.034738270000048],
          [120.22720377300004, 36.03473768200007],
          [120.22720525400007, 36.034737316000076],
          [120.22720692500002, 36.034737147000044],
          [120.22720842700005, 36.034737219000078],
          [120.22720999600006, 36.034737462000066],
          [120.22721154200008, 36.034738093000044],
          [120.22721320100004, 36.034739030000026],
          [120.22721442500006, 36.034740265000039],
          [120.22721516900003, 36.034741344000054],
          [120.22721576900005, 36.034742855000047],
          [120.22721594500001, 36.034744337000063],
          [120.22721534600009, 36.034746865000045],
          [120.22721416600007, 36.034748578000062],
          [120.22721322600012, 36.034749311000041],
          [120.22721894800009, 36.034746376000044],
          [120.22722591200011, 36.034742215000051],
          [120.22723188700002, 36.03474986100008],
          [120.22724404000007, 36.034743939000066],
          [120.2272682360001, 36.034774491000064],
          [120.22728514400001, 36.034797704000027],
          [120.22726637800008, 36.034806721000052],
          [120.22785949100012, 36.035573074000069],
          [120.22786760100007, 36.035582993000048],
          [120.22786813400012, 36.035583645000031],
          [120.22786115500003, 36.035587406000047],
          [120.22786216600002, 36.035587157000066],
          [120.22786383700009, 36.035586988000034],
          [120.22786533900012, 36.035587059000079],
          [120.22786690900011, 36.035587302000067],
          [120.22786845400003, 36.035587933000045],
          [120.22787011300011, 36.035588870000026],
          [120.22787133700001, 36.03559010500004],
          [120.22787208200009, 36.035591184000054],
          [120.22787268200011, 36.035592694000059],
          [120.22787285700008, 36.035594177000064],
          [120.22787225800005, 36.035596705000046],
          [120.22787107800002, 36.035598418000063],
          [120.22786908500007, 36.035599972000057],
          [120.22786621500006, 36.035601031000056],
          [120.22786316600002, 36.03560120700007],
          [120.22785801200007, 36.035603836000064],
          [120.22785922000003, 36.03560539800003],
          [120.22796743800006, 36.035745619000068],
          [120.22796971200012, 36.035748556000044],
          [120.22797681800012, 36.035744924000028],
          [120.22797790000004, 36.035743772000046],
          [120.22797947300012, 36.035742772000049],
          [120.22798081300004, 36.035742184000071],
          [120.22798229300008, 36.035741818000076],
          [120.22798396500002, 36.035741650000034],
          [120.22798546600006, 36.035741721000079],
          [120.22798703600006, 36.035741963000078],
          [120.22798858100009, 36.035742596000034],
          [120.22799024000005, 36.035743533000073],
          [120.22799146400007, 36.03574476700004],
          [120.22799220900004, 36.035745846000054],
          [120.22799280900006, 36.035747357000048],
          [120.22799298400002, 36.035748840000053],
          [120.22799267700009, 36.035750137000036],
          [120.2279923860001, 36.035751367000046],
          [120.22799120500008, 36.035753081000053],
          [120.22798921200001, 36.035754635000046],
          [120.22799418200009, 36.035751837000078],
          [120.22799987400003, 36.035748883000053],
          [120.22800788000006, 36.035757551000074],
          [120.22802065700012, 36.03575124200006],
          [120.22808143100008, 36.035830529000066],
          [120.22806609600002, 36.035838349000073],
          [120.22830604100011, 36.036148794000042],
          [120.2283103850001, 36.036147365000033],
          [120.22831793700004, 36.036145654000052],
          [120.22832626200011, 36.036145113000032],
          [120.22833108300006, 36.036145093000073],
          [120.22833812500005, 36.036146047000045],
          [120.22834683200006, 36.036149085000034],
          [120.22835051700008, 36.036151866000068],
          [120.2283751540001, 36.03618401600005],
          [120.22837722100007, 36.036187667000036],
          [120.22837781300007, 36.036191083000062],
          [120.22837749300004, 36.036194837000039],
          [120.2283771540001, 36.036198893000062],
          [120.22837409100009, 36.036204628000064],
          [120.22837146600011, 36.036208715000043],
          [120.22835967900005, 36.036219380000034],
          [120.22858656400001, 36.036512266000045],
          [120.22859791400003, 36.036507042000039],
          [120.22860580800011, 36.036517882000055],
          [120.22861562200001, 36.036519284000065],
          [120.22862234900003, 36.036520784000061],
          [120.22862819900001, 36.036523804000069],
          [120.22863183300001, 36.036526799000058],
          [120.22863386400002, 36.036529329000075],
          [120.22880795700007, 36.036457764000033],
          [120.22880196400001, 36.03645378300007],
          [120.22880189600005, 36.036450968000054],
          [120.22880709200001, 36.036446620000049],
          [120.22881199800008, 36.036442647000058],
          [120.22913008800003, 36.03632366800008],
          [120.22913610600006, 36.036320985000032],
          [120.22879242200008, 36.035877382000024],
          [120.22877086900007, 36.035850006000032],
          [120.22842279500003, 36.035399098000028],
          [120.22840138600009, 36.035372039000038],
          [120.22805468700005, 36.034923113000048],
          [120.22803178400011, 36.034894457000064],
          [120.22768534500005, 36.034444958000051],
          [120.22766340300007, 36.03441734900008],
          [120.22731593300011, 36.033970089000036],
          [120.22728209800005, 36.033926789000077],
          [120.22696763800002, 36.033518103000063],
          [120.22693319100006, 36.033475212000042],
          [120.22650859000009, 36.032926690000068],
          [120.22647945200004, 36.032890950000024],
          [120.22634214800007, 36.032712510000067],
          [120.22612831700008, 36.032434614000067],
          [120.22610693500008, 36.032407294000052],
          [120.22592655500011, 36.032173054000054],
          [120.22590300100001, 36.032141352000053],
          [120.22568715900002, 36.031864398000039]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 783,
      "bh": "0302",
      "mc": "小港池1号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.01376996262854847,
      "shape_Area": 2.9972716011814979e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22487519800006, 36.032735466000076],
          [120.22798796500001, 36.036768297000037],
          [120.22799452100003, 36.036776790000033],
          [120.22801935300004, 36.03680896000003],
          [120.22802654100008, 36.03680513900008],
          [120.22805268500008, 36.036837423000065],
          [120.22822060300007, 36.036840274000042],
          [120.22853705800003, 36.036709469000073],
          [120.22851519300002, 36.036654664000025],
          [120.22819243900005, 36.036238278000042],
          [120.22817356600001, 36.036247217000039],
          [120.22814540200011, 36.036211236000042],
          [120.22816400000011, 36.036201060000053],
          [120.22785676700005, 36.035803000000044],
          [120.22787282100001, 36.03579432500004],
          [120.22776446000012, 36.035657374000039],
          [120.22775900400006, 36.035660001000053],
          [120.22775509200005, 36.035654365000028],
          [120.22774415400011, 36.03565890200008],
          [120.22742749600002, 36.035250499000028],
          [120.22741044300005, 36.035258903000056],
          [120.22738230700008, 36.035218881000048],
          [120.22739839200005, 36.035209975000043],
          [120.22707361900007, 36.03478893700003],
          [120.22708451500012, 36.034778078000045],
          [120.22708335400011, 36.034776574000034],
          [120.22708231600006, 36.034778082000059],
          [120.22708032200001, 36.034779635000064],
          [120.22707745300011, 36.034780694000062],
          [120.22707440300007, 36.034780870000077],
          [120.22707120300004, 36.03478007700005],
          [120.22706925800003, 36.034778938000045],
          [120.22706766200008, 36.034777279000025],
          [120.22706660000006, 36.034775366000076],
          [120.22706636500004, 36.034773821000044],
          [120.22706667300008, 36.034772529000065],
          [120.22706709000011, 36.034771288000059],
          [120.2270679290001, 36.034769925000035],
          [120.22706901100003, 36.034768772000064],
          [120.2270705840001, 36.034767773000056],
          [120.22707192400003, 36.034767184000032],
          [120.22707340400007, 36.034766819000026],
          [120.22707507600001, 36.034766650000051],
          [120.22707571700005, 36.034766680000075],
          [120.22698747700008, 36.034652376000054],
          [120.2269863140001, 36.034653282000079],
          [120.2269834440001, 36.034654341000078],
          [120.22698039400007, 36.034654517000035],
          [120.22697719400003, 36.034653724000066],
          [120.22697524900002, 36.034652584000071],
          [120.22697365300007, 36.034650925000051],
          [120.22697259100005, 36.034649012000045],
          [120.22697235600003, 36.03464746800006],
          [120.22697266400007, 36.034646176000024],
          [120.2269730810001, 36.034644935000074],
          [120.22697392700002, 36.034643569000025],
          [120.22697391800011, 36.034643557000038],
          [120.22697203000007, 36.034641065000073],
          [120.22696132300007, 36.034647259000053],
          [120.22666537400005, 36.034263207000038],
          [120.2266458790001, 36.034271771000078],
          [120.2266094360001, 36.034224179000034],
          [120.22662792400001, 36.034215140000072],
          [120.2263227740001, 36.033817393000049],
          [120.22633651800004, 36.033811044000061],
          [120.22633608400008, 36.033810478000078],
          [120.22633446200007, 36.033811743000058],
          [120.22633159200007, 36.033812801000067],
          [120.22632854300002, 36.033812977000025],
          [120.2263253430001, 36.033812184000055],
          [120.2263233970001, 36.033811044000061],
          [120.22632180200003, 36.03380938600003],
          [120.22632074000001, 36.033807472000035],
          [120.22632050400011, 36.033805928000049],
          [120.22632081300003, 36.03380463600007],
          [120.22632123000005, 36.033803395000064],
          [120.22632206900005, 36.03380203200004],
          [120.22632315100009, 36.033800880000058],
          [120.22632472400005, 36.033799879000071],
          [120.22632606400009, 36.033799292000026],
          [120.22632727100006, 36.033798993000062],
          [120.22623942300004, 36.033684526000059],
          [120.22623884600011, 36.033684977000064],
          [120.22623597600011, 36.033686035000073],
          [120.22623292600008, 36.033686211000031],
          [120.22622972600004, 36.033685419000051],
          [120.22622778000004, 36.033684279000056],
          [120.22622618500009, 36.033682620000036],
          [120.22622512400005, 36.03368070700003],
          [120.22622488700006, 36.033679163000045],
          [120.22622519600009, 36.033677871000066],
          [120.22622561300011, 36.033676630000059],
          [120.22622620200002, 36.033675674000051],
          [120.22622252800011, 36.03367105600006],
          [120.22621213600007, 36.033676789000026],
          [120.22589485100002, 36.033268349000025],
          [120.22587518100011, 36.033276612000066],
          [120.22584545900008, 36.033233384000027],
          [120.22586165900009, 36.033224672000074],
          [120.22556066200002, 36.032835165000051],
          [120.22557120900001, 36.03282893800008],
          [120.22556882800006, 36.032825765000041],
          [120.22556822400009, 36.03282598800007],
          [120.22556517600003, 36.032826164000028],
          [120.22556197500012, 36.032825371000058],
          [120.22556003000011, 36.032824231000063],
          [120.22555843400005, 36.032822573000033],
          [120.22555737300002, 36.032820659000038],
          [120.22555713700001, 36.032819115000052],
          [120.22555744600004, 36.032817823000073],
          [120.22555786300006, 36.032816582000066],
          [120.22555870300005, 36.032815219000042],
          [120.2255597840001, 36.032814067000061],
          [120.22556135600007, 36.032813066000074],
          [120.22556269600011, 36.032812479000029],
          [120.22556387200007, 36.032812188000037],
          [120.22547462200009, 36.03269784500003],
          [120.22547458500003, 36.032697900000073],
          [120.22547259200007, 36.032699454000067],
          [120.22546972100008, 36.032700513000066],
          [120.22546667300003, 36.032700688000034],
          [120.22546347200011, 36.032699896000054],
          [120.22546152700011, 36.032698756000059],
          [120.22545993200004, 36.032697098000028],
          [120.22545887000001, 36.032695184000033],
          [120.22545863400001, 36.032693639000058],
          [120.22545894300004, 36.032692348000069],
          [120.22545936000006, 36.032691106000073],
          [120.22546020000004, 36.032689744000038],
          [120.22546128200008, 36.032688591000067],
          [120.22546285300007, 36.032687591000069],
          [120.22546419300011, 36.032687003000035],
          [120.22546567300003, 36.03268663800003],
          [120.22546586100009, 36.03268661900006],
          [120.22546554200005, 36.032686211000055],
          [120.22544929100002, 36.032692109000038],
          [120.22512619300005, 36.032273654000051],
          [120.22510540000007, 36.032284247000064],
          [120.22507480200011, 36.03224461700006],
          [120.22509612200008, 36.032233757000029],
          [120.2248590050001, 36.031926656000053],
          [120.22485401100005, 36.031920300000024],
          [120.22486500500008, 36.031914577000066],
          [120.22486344900005, 36.031912527000031],
          [120.22480400900008, 36.031834205000052],
          [120.22478305800007, 36.031814643000075],
          [120.22477008600004, 36.031811231000063],
          [120.22472975300002, 36.031818491000024],
          [120.22466212600011, 36.031853092000063],
          [120.22462814100004, 36.031870482000045],
          [120.22430338700008, 36.032036642000037],
          [120.22436321100008, 36.032113815000059],
          [120.22437384600005, 36.032107460000077],
          [120.22438405800006, 36.032120434000035],
          [120.22437291100005, 36.032126213000026],
          [120.22456319600008, 36.032369429000028],
          [120.2245854140001, 36.032360003000065],
          [120.22487519800006, 36.032735466000076]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 786,
      "bh": "0302",
      "mc": "小港池2号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.01328336502452112,
      "shape_Area": 2.9054831294732869e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22466692900002, 36.03273872300008],
          [120.22444435800003, 36.032446545000028],
          [120.2244541880001, 36.032441194000057],
          [120.22429372000011, 36.032233894000058],
          [120.22384468700011, 36.032462199000065],
          [120.22406704100001, 36.032748104000063],
          [120.22415390000003, 36.032859789000042],
          [120.22414977000005, 36.032862213000044],
          [120.22415017100002, 36.032864320000044],
          [120.22415024400004, 36.032865747000073],
          [120.22414948100004, 36.032867329000055],
          [120.22414865100006, 36.032868331000032],
          [120.22414725700003, 36.032869123000069],
          [120.2241461970001, 36.032869297000047],
          [120.22425902200007, 36.033015280000029],
          [120.22427002500001, 36.033009684000035],
          [120.22427637700002, 36.033018224000045],
          [120.22461710400012, 36.033456625000042],
          [120.22460677400011, 36.033461797000029],
          [120.2246121500001, 36.033469109000066],
          [120.22461308600009, 36.033469032000028],
          [120.22461486000009, 36.033469446000026],
          [120.22461645300007, 36.033470408000028],
          [120.22461726600011, 36.033471199000076],
          [120.22461766700008, 36.033473307000065],
          [120.22461773900011, 36.033474734000038],
          [120.22461697600011, 36.03347631500003],
          [120.22461614600002, 36.033477318000052],
          [120.22461502700003, 36.033477954000034],
          [120.22472824900001, 36.033619798000075],
          [120.22472827200011, 36.033619634000047],
          [120.2247293910001, 36.033617916000026],
          [120.22473070100011, 36.03361740500003],
          [120.22473315200011, 36.033616729000073],
          [120.22473520500012, 36.033616559000052],
          [120.22473697900011, 36.03361697400004],
          [120.22473857300008, 36.033617935000052],
          [120.22473938500002, 36.033618727000032],
          [120.2247397860001, 36.033620834000033],
          [120.22473985800002, 36.033622260000072],
          [120.22473909500002, 36.033623843000044],
          [120.22473826500004, 36.033624845000077],
          [120.22473766400003, 36.033625187000041],
          [120.22474090300011, 36.033629934000032],
          [120.22474956700012, 36.033625678000078],
          [120.22509602300011, 36.034074013000065],
          [120.22508391500003, 36.03408020300003],
          [120.22508639300008, 36.034083787000043],
          [120.22508965500003, 36.034087911000029],
          [120.22508965300005, 36.034087790000058],
          [120.22508986200012, 36.034086281000043],
          [120.22509098100011, 36.034084563000079],
          [120.22509229100001, 36.034084050000047],
          [120.22509474200001, 36.034083374000033],
          [120.22509679600012, 36.034083205000059],
          [120.22509856900001, 36.034083619000057],
          [120.22510016400008, 36.034084581000059],
          [120.22510097500003, 36.03408537200005],
          [120.22510137600011, 36.034087480000039],
          [120.22510144900002, 36.034088907000069],
          [120.22510068500003, 36.034090488000061],
          [120.22509985600004, 36.034091491000027],
          [120.22509846100002, 36.034092283000064],
          [120.22509624000008, 36.034092648000069],
          [120.22509437500003, 36.034092601000054],
          [120.22509311600004, 36.034092286000032],
          [120.22520839000003, 36.034238006000066],
          [120.2252125550001, 36.034241887000064],
          [120.22521647400004, 36.034239512000056],
          [120.22521970200012, 36.034244007000041],
          [120.22522672200012, 36.034241173000055],
          [120.22555986400005, 36.034672103000048],
          [120.22555071300008, 36.034677068000065],
          [120.22555845000011, 36.034686172000079],
          [120.22555958400005, 36.034685859000035],
          [120.22556163700006, 36.034685689000071],
          [120.22556341100005, 36.034686104000059],
          [120.22556500400003, 36.03468706600006],
          [120.22556581600008, 36.034687857000051],
          [120.22556621700005, 36.034689965000041],
          [120.22556629100006, 36.03469139200007],
          [120.22556552600008, 36.034692973000062],
          [120.2255646970001, 36.034693976000028],
          [120.22556330300006, 36.034694768000065],
          [120.22556108200001, 36.034695133000071],
          [120.22555939500012, 36.034695090000071],
          [120.22567588200002, 36.034843296000076],
          [120.22568754700001, 36.034836760000076],
          [120.22605839700009, 36.035316572000056],
          [120.22604729300008, 36.03532277000005],
          [120.22604996400003, 36.035326186000077],
          [120.22605045700004, 36.035325993000072],
          [120.22605290900003, 36.035325317000058],
          [120.22605496300002, 36.035325148000027],
          [120.22605673600003, 36.035325562000025],
          [120.22605833000011, 36.035326524000027],
          [120.22605914200005, 36.035327315000075],
          [120.22605954300002, 36.035329423000064],
          [120.22605961600004, 36.035330850000037],
          [120.22605885300004, 36.035332431000029],
          [120.22605802200007, 36.035333434000052],
          [120.22605662900003, 36.035334226000032],
          [120.22605623800007, 36.035334291000026],
          [120.22616425600006, 36.035473810000042],
          [120.2261642740001, 36.035473675000048],
          [120.22616539400008, 36.035471957000027],
          [120.22616670200011, 36.035471445000042],
          [120.22616915500009, 36.035470769000028],
          [120.2261712080001, 36.035470599000064],
          [120.22617298200009, 36.035471014000052],
          [120.22617457500007, 36.035471975000064],
          [120.22617538700001, 36.035472768000034],
          [120.22617578800009, 36.035474875000034],
          [120.2261758620001, 36.035476301000074],
          [120.22617509700001, 36.035477883000055],
          [120.22617426800002, 36.035478885000032],
          [120.22617293500002, 36.035479643000031],
          [120.22617668500004, 36.035483820000024],
          [120.2261852580001, 36.03547917700007],
          [120.22652865100008, 36.035923913000033],
          [120.22652049600003, 36.035928366000064],
          [120.22652593500004, 36.035934822000058],
          [120.22652723200008, 36.035934714000064],
          [120.22652900500009, 36.035935128000062],
          [120.22653059900006, 36.035936090000064],
          [120.22653141100011, 36.035936882000044],
          [120.22653181200008, 36.035938989000044],
          [120.2265318850001, 36.035940416000074],
          [120.2265311220001, 36.035941998000055],
          [120.22653029100002, 36.035943000000032],
          [120.22652889700009, 36.035943792000069],
          [120.22652761500001, 36.035944003000054],
          [120.22664060500006, 36.036088578000033],
          [120.22664034200011, 36.036087937000048],
          [120.22664032700004, 36.036086717000046],
          [120.2266405360001, 36.036085209000078],
          [120.22664165500009, 36.036083491000056],
          [120.22664296400001, 36.036082978000024],
          [120.2266454170001, 36.036082302000068],
          [120.2266474700001, 36.036082133000036],
          [120.22664924300011, 36.036082547000035],
          [120.22665083700008, 36.036083509000036],
          [120.22665165000001, 36.036084300000027],
          [120.22665205100009, 36.036086408000074],
          [120.22665212300001, 36.036087835000046],
          [120.22665136000001, 36.036089416000038],
          [120.22665053000003, 36.036090419000061],
          [120.22664913600011, 36.036091211000041],
          [120.22664691500006, 36.036091576000047],
          [120.22664504800002, 36.036091529000032],
          [120.22664331400006, 36.036091095000074],
          [120.22664974800011, 36.036098837000054],
          [120.22665915200002, 36.036093771000026],
          [120.22700788400005, 36.036539927000035],
          [120.22699442500004, 36.036546357000077],
          [120.22711397700004, 36.036703405000026],
          [120.22711808800011, 36.03670087900008],
          [120.22712593400001, 36.036710089000053],
          [120.22713406800005, 36.036706309000067],
          [120.22752396800001, 36.03720884300003],
          [120.22796112700007, 36.036984100000041],
          [120.22787872300012, 36.036879716000044],
          [120.22785559600004, 36.03684989900006],
          [120.22784922800008, 36.036841690000074],
          [120.22466692900002, 36.03273872300008]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 787,
      "bh": "0302",
      "mc": "小港池3号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.013297115489421611,
      "shape_Area": 3.0190202798233353e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22684908000008, 36.037367711000059],
          [120.22687138300012, 36.037396671000067],
          [120.22687488400004, 36.037394784000071],
          [120.22690083700002, 36.03742096600007],
          [120.22710296600007, 36.037424051000073],
          [120.22740939400001, 36.037266927000076],
          [120.22701177300007, 36.036755389000064],
          [120.22702467700003, 36.036749246000056],
          [120.22690565300002, 36.036595119000026],
          [120.22689406100005, 36.03660108400004],
          [120.22661684500008, 36.036243090000028],
          [120.22662640800002, 36.036238445000038],
          [120.22662455300008, 36.036235789000045],
          [120.22661018100007, 36.03624338000003],
          [120.2266018790001, 36.036233580000044],
          [120.2265984390001, 36.036234628000045],
          [120.22659599300005, 36.036234354000044],
          [120.22659358300007, 36.036233128000049],
          [120.22656949400005, 36.036200122000025],
          [120.22656871900006, 36.036196931000063],
          [120.22657208200008, 36.036195244000055],
          [120.22655404500006, 36.036172608000072],
          [120.22655390800003, 36.036171483000032],
          [120.22657005100007, 36.036163138000063],
          [120.22655333300008, 36.036141881000049],
          [120.22655590700003, 36.03614045900008],
          [120.22655262300009, 36.03613686500006],
          [120.22655214700001, 36.036137441000051],
          [120.22655075300008, 36.036138233000031],
          [120.22654853200004, 36.036138597000047],
          [120.22654666500011, 36.036138550000032],
          [120.22654493100003, 36.036138116000075],
          [120.22654354800011, 36.036137161000056],
          [120.22654245300009, 36.036136162000048],
          [120.22654195900009, 36.036134958000048],
          [120.22654194400002, 36.036133739000036],
          [120.22654215300008, 36.036132230000078],
          [120.22654327200007, 36.036130512000057],
          [120.2265445810001, 36.036130000000071],
          [120.22654674600005, 36.036129403000075],
          [120.22643809800002, 36.035991461000037],
          [120.22643744200002, 36.035992253000074],
          [120.2264360480001, 36.035993045000055],
          [120.22643382600006, 36.035993409000071],
          [120.22643196100012, 36.035993362000056],
          [120.22643022500006, 36.035992929000031],
          [120.22642884300001, 36.035991974000069],
          [120.22642774800011, 36.035990975000061],
          [120.2264272540001, 36.035989771000061],
          [120.22642723900003, 36.035988551000059],
          [120.22642744800009, 36.035987043000034],
          [120.22642856700008, 36.03598532400008],
          [120.2264298770001, 36.035984812000038],
          [120.2264323280001, 36.035984136000025],
          [120.2264272110001, 36.035977829000046],
          [120.22641504600006, 36.035983918000056],
          [120.22607102600011, 36.035537982000051],
          [120.22608461800007, 36.035531375000062],
          [120.22608241700004, 36.035527827000067],
          [120.22608146800007, 36.035526619000052],
          [120.22608153300007, 36.035528001000046],
          [120.22608077000007, 36.035529584000074],
          [120.22607994000009, 36.03553058500006],
          [120.22607854600005, 36.03553137800003],
          [120.22607632500001, 36.035531743000035],
          [120.22607445900007, 36.035531695000032],
          [120.22607272400012, 36.035531261000074],
          [120.22607134200007, 36.035530307000045],
          [120.22607024600006, 36.035529308000037],
          [120.22606975200006, 36.035528104000036],
          [120.22606973800009, 36.035526884000035],
          [120.22606994600005, 36.035525375000077],
          [120.22607106500004, 36.035523657000056],
          [120.22607237500006, 36.03552314500007],
          [120.22607482700005, 36.035522469000057],
          [120.22607688000005, 36.035522299000036],
          [120.22607831100004, 36.035522633000028],
          [120.22596642000008, 36.035381126000061],
          [120.22596600600002, 36.035381983000036],
          [120.22596517600005, 36.035382985000069],
          [120.22596378200001, 36.03538377700005],
          [120.22596156100008, 36.035384142000055],
          [120.22595969500003, 36.03538409500004],
          [120.22595796000007, 36.035383661000026],
          [120.22595657800002, 36.035382707000053],
          [120.22595548200002, 36.035381708000045],
          [120.22595498900012, 36.035380504000045],
          [120.22595497400005, 36.035379283000054],
          [120.22595518300011, 36.035377775000029],
          [120.2259563020001, 36.035376057000065],
          [120.22595761100001, 36.035375545000079],
          [120.22596006300012, 36.035374869000066],
          [120.2259613870001, 36.035374759000035],
          [120.22596032900003, 36.035373422000077],
          [120.22595542900001, 36.035367248000057],
          [120.22594251400005, 36.035374107000052],
          [120.22557745500001, 36.034900563000065],
          [120.22558684900002, 36.034895758000062],
          [120.22558294000009, 36.034890982000036],
          [120.22558284600007, 36.034891175000041],
          [120.22558201700008, 36.034892178000064],
          [120.22558062200005, 36.034892970000044],
          [120.22557840000002, 36.034893335000049],
          [120.22557653500007, 36.034893287000045],
          [120.22557480000012, 36.034892854000077],
          [120.22557341800007, 36.034891899000058],
          [120.22557232200006, 36.03489090000005],
          [120.22557182800006, 36.034889695000061],
          [120.2255718130001, 36.034888476000049],
          [120.22557202200005, 36.034886967000034],
          [120.22557314100004, 36.03488524900007],
          [120.22557445100006, 36.034884737000027],
          [120.22557690300005, 36.034884061000071],
          [120.22557895600005, 36.034883892000039],
          [120.22557931400002, 36.034883975000071],
          [120.22546528900011, 36.034734839000066],
          [120.22546262300011, 36.034731211000064],
          [120.22546051500001, 36.034732179000059],
          [120.2254637850001, 36.034736451000072],
          [120.22545237300005, 36.034742211000037],
          [120.22510640600001, 36.034292248000042],
          [120.2251193510001, 36.034286402000077],
          [120.22511834400007, 36.034285114000056],
          [120.22511805100009, 36.03428572200005],
          [120.22511722200011, 36.034286724000026],
          [120.22511582700008, 36.034287516000063],
          [120.22511360500005, 36.034287881000068],
          [120.2251117400001, 36.034287834000054],
          [120.22511000500003, 36.034287400000039],
          [120.2251086230001, 36.034286445000077],
          [120.22510752700009, 36.034285447000059],
          [120.22510703300009, 36.034284242000069],
          [120.22510701900001, 36.034283022000068],
          [120.22510722800007, 36.034281514000043],
          [120.22510834600007, 36.034279796000078],
          [120.22510965600009, 36.034279284000036],
          [120.22511210800008, 36.034278608000079],
          [120.22511319700004, 36.034278517000075],
          [120.22500519100004, 36.03414013500003],
          [120.22500521900008, 36.03414067500006],
          [120.2250044540001, 36.034142258000031],
          [120.22500362500011, 36.034143260000064],
          [120.22500223000009, 36.034144052000045],
          [120.22500000900004, 36.03414441700005],
          [120.2249981440001, 36.034144369000046],
          [120.22499640900003, 36.034143935000031],
          [120.2249950260001, 36.034142981000059],
          [120.2249939300001, 36.034141982000051],
          [120.22499343700008, 36.034140778000051],
          [120.22499342200001, 36.034139558000049],
          [120.22499363200006, 36.034138049000035],
          [120.22499475100005, 36.03413633100007],
          [120.22499606000008, 36.034135819000028],
          [120.22499851200007, 36.034135144000061],
          [120.22500056600006, 36.03413497300005],
          [120.22500129500008, 36.034135144000061],
          [120.22499985900004, 36.034133303000033],
          [120.22498757100004, 36.034139614000026],
          [120.22463054100001, 36.033677901000033],
          [120.22464132400012, 36.033672789000036],
          [120.22452890900001, 36.033527149000065],
          [120.22452812200004, 36.03352809900008],
          [120.22452672800011, 36.03352889100006],
          [120.22452450700007, 36.033529256000065],
          [120.22452264100002, 36.033529208000061],
          [120.22452090600007, 36.033528774000047],
          [120.22451952300003, 36.033527820000074],
          [120.22451842900011, 36.033526821000066],
          [120.22451793500011, 36.033525617000066],
          [120.22451792000004, 36.033524397000065],
          [120.2245181290001, 36.03352288800005],
          [120.22451924800009, 36.033521170000029],
          [120.22452055700001, 36.033520659000033],
          [120.22452300900011, 36.033519983000076],
          [120.22452335500009, 36.033519954000042],
          [120.22451867200004, 36.033514159000049],
          [120.22450539200008, 36.033521084000029],
          [120.22447379500011, 36.033480325000028],
          [120.22448337200001, 36.03347476600004],
          [120.2244770530001, 36.033466715000031],
          [120.22446189800007, 36.033474645000069],
          [120.22445580400006, 36.033467095000049],
          [120.22444974000007, 36.033459372000038],
          [120.22442634400011, 36.033428786000059],
          [120.22441540500006, 36.033412750000025],
          [120.22442098900001, 36.03340965700005],
          [120.22415859300008, 36.033070688000066],
          [120.22417110400011, 36.033064326000044],
          [120.22416981000003, 36.033062447000077],
          [120.22416936900004, 36.033061881000037],
          [120.22416920500007, 36.03306222100008],
          [120.22416837600008, 36.033063224000045],
          [120.22416698100005, 36.033064016000026],
          [120.22416475900002, 36.033064381000031],
          [120.22416289400007, 36.033064333000027],
          [120.22416115900012, 36.033063900000059],
          [120.22415977700007, 36.033062944000051],
          [120.22415868100006, 36.033061946000032],
          [120.22415818700006, 36.033060741000043],
          [120.22415817300009, 36.03305952200003],
          [120.22415838100005, 36.033058014000062],
          [120.22415950100003, 36.033056296000041],
          [120.22416081100005, 36.033055783000066],
          [120.22416326200005, 36.033055107000052],
          [120.22416405000001, 36.033055042000058],
          [120.22405716500009, 36.032917625000039],
          [120.22405655700004, 36.032918360000053],
          [120.22405516300012, 36.032919151000044],
          [120.22405294100008, 36.032919517000039],
          [120.22405107600002, 36.032919469000035],
          [120.22404934100007, 36.032919035000077],
          [120.22404795800003, 36.032918080000059],
          [120.22404686300001, 36.032917081000051],
          [120.22404636900001, 36.03291587700005],
          [120.22404635400005, 36.032914658000038],
          [120.2240465640001, 36.032913149000024],
          [120.2240476820001, 36.032911431000059],
          [120.22404899200001, 36.032910919000074],
          [120.22405142700006, 36.03291024400005],
          [120.22405044800007, 36.032908989000077],
          [120.22405092400004, 36.032909637000046],
          [120.22403914500001, 36.032915718000027],
          [120.22403455200003, 36.032909910000058],
          [120.22391154900004, 36.032750536000037],
          [120.22373288600011, 36.032519042000047],
          [120.2234109640001, 36.032682717000057],
          [120.2234031590001, 36.032694190000029],
          [120.22339805800004, 36.032704641000066],
          [120.22339148700007, 36.032717799000068],
          [120.22338528900002, 36.032736247000059],
          [120.22338173100002, 36.032758817000058],
          [120.22338118700009, 36.032781472000067],
          [120.22338242500007, 36.032788391000054],
          [120.22338449000006, 36.032796844000075],
          [120.22345327000005, 36.032940328000052],
          [120.22345746500002, 36.032953174000056],
          [120.22346095500006, 36.032967588000076],
          [120.22346181000012, 36.032982747000062],
          [120.22346050200008, 36.032990677000043],
          [120.2234856660001, 36.033023185000047],
          [120.22348589000001, 36.033023474000061],
          [120.22349163100012, 36.033030712000027],
          [120.22349153400012, 36.033030763000056],
          [120.22630966200006, 36.036670487000038],
          [120.22684269400008, 36.037359783000056],
          [120.22684908000008, 36.037367711000059]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 788,
      "bh": "0302",
      "mc": "小港池5号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.012217439913638056,
      "shape_Area": 2.3300290312153794e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22363585300002, 36.034484465000048],
          [120.22363294400009, 36.034478853000053],
          [120.22363160200007, 36.034477629000037],
          [120.22363095500009, 36.03447605000008],
          [120.22363093800004, 36.034474594000073],
          [120.22363118400006, 36.034472814000026],
          [120.22363262700003, 36.034470597000052],
          [120.22364552400006, 36.03446402000003],
          [120.22363819700001, 36.03445454000007],
          [120.22356291800008, 36.034355774000062],
          [120.22356168400006, 36.034354140000062],
          [120.22355058800008, 36.034359668000036],
          [120.22354014900009, 36.034346106000044],
          [120.22354687300003, 36.034341727000026],
          [120.22332443800008, 36.03405077900004],
          [120.22330902900001, 36.034057541000038],
          [120.22324925400005, 36.034086886000068],
          [120.22320507800009, 36.034108573000026],
          [120.22288722100006, 36.034264614000051],
          [120.22289786800002, 36.034278568000047],
          [120.22289761500008, 36.034278696000058],
          [120.22289092400001, 36.034282063000035],
          [120.22289561800005, 36.034287668000047],
          [120.22292740500006, 36.034325630000069],
          [120.22290770300003, 36.03433532400004],
          [120.22297461100004, 36.034424186000024],
          [120.22298068600003, 36.034432016000039],
          [120.22421058400005, 36.036017281000056],
          [120.22421617900011, 36.03602449300007],
          [120.22459035400004, 36.03650676500007],
          [120.22473027700005, 36.036686816000042],
          [120.22473671800003, 36.036695104000046],
          [120.22506667000005, 36.037119675000042],
          [120.22521852800003, 36.037316727000075],
          [120.22522316700008, 36.037322747000076],
          [120.22573297800011, 36.037984272000074],
          [120.2257230460001, 36.037993093000068],
          [120.22572792700009, 36.037988803000076],
          [120.22575685700008, 36.03800841900005],
          [120.22582382900009, 36.038021964000052],
          [120.22597243200005, 36.037999231000072],
          [120.2262400410001, 36.037862638000036],
          [120.22586153700001, 36.037368380000032],
          [120.22585767900011, 36.037370232000058],
          [120.22584610000001, 36.03735514300007],
          [120.22584941500008, 36.037353539000037],
          [120.22582412000008, 36.037320859000033],
          [120.22582212400005, 36.037316050000072],
          [120.22582072900002, 36.037314601000048],
          [120.22581980700011, 36.037312938000071],
          [120.22581961800006, 36.037311705000036],
          [120.22581988100001, 36.037310608000041],
          [120.22582025300005, 36.037309500000049],
          [120.22582098500004, 36.03730831200005],
          [120.22582189900004, 36.037307338000062],
          [120.22582326200006, 36.037306470000033],
          [120.22582440000008, 36.03730597100008],
          [120.22582565800008, 36.037305661000062],
          [120.22582711100006, 36.037305515000071],
          [120.22582841900009, 36.037305576000051],
          [120.22582973600004, 36.037305780000054],
          [120.22583104700004, 36.03730631600007],
          [120.22583435600006, 36.037303697000027],
          [120.22574886500001, 36.037190919000068],
          [120.22574644000008, 36.037187772000038],
          [120.2257453850001, 36.037188308000054],
          [120.22573897600012, 36.037191565000057],
          [120.22573807300012, 36.037192877000052],
          [120.22573650300001, 36.037194101000068],
          [120.22573421600009, 36.037194944000078],
          [120.22573183300005, 36.037195082000039],
          [120.22572924800011, 36.037194442000043],
          [120.22572776000004, 36.037193570000056],
          [120.22572646000003, 36.037192219000076],
          [120.22572560300011, 36.037190674000044],
          [120.22572543700005, 36.037189587000057],
          [120.22572130800006, 36.037184819000061],
          [120.22571898700005, 36.037186145000078],
          [120.22526482900003, 36.036592559000042],
          [120.22526906100006, 36.03659083000008],
          [120.22526713400009, 36.036590941000043],
          [120.22526432500001, 36.03659024500007],
          [120.22526267300009, 36.036589277000076],
          [120.22526126600008, 36.036587815000075],
          [120.22526033500003, 36.036586136000039],
          [120.22526014300001, 36.036584884000035],
          [120.22526040800005, 36.036583775000054],
          [120.22526078300007, 36.036582657000054],
          [120.2252615220001, 36.036581458000057],
          [120.22526244700009, 36.036580473000072],
          [120.22526382400008, 36.03657959800006],
          [120.22527281800001, 36.036575027000026],
          [120.22527392900008, 36.036574462000033],
          [120.2252723580001, 36.036572425000031],
          [120.2251869270001, 36.036456988000054],
          [120.22518137500003, 36.036459699000034],
          [120.22518032100004, 36.036460153000064],
          [120.22516424900004, 36.036467093000056],
          [120.22470871200005, 36.035873003000063],
          [120.22470662600006, 36.035865967000063],
          [120.22470525400001, 36.035864539000045],
          [120.22470434500008, 36.035862902000076],
          [120.22470416200008, 36.035861701000044],
          [120.22470442000008, 36.035860624000065],
          [120.22470478700006, 36.035859529000049],
          [120.22470550700007, 36.035858359000031],
          [120.22470640400002, 36.035857404000069],
          [120.22470774700002, 36.035856550000062],
          [120.22470886300005, 36.035856060000071],
          [120.22471009800006, 36.035855756000046],
          [120.22471152800006, 36.035855611000045],
          [120.22471281500009, 36.035855672000025],
          [120.22471410800006, 36.03585587200007],
          [120.22471423000002, 36.035855760000061],
          [120.22471821900001, 36.035852101000046],
          [120.22462902100006, 36.035736407000059],
          [120.22462711900005, 36.035733948000029],
          [120.22414091500002, 36.03510570800006],
          [120.22405119900009, 36.034988852000026],
          [120.22404462800012, 36.034993257000053],
          [120.22404375600001, 36.034995063000054],
          [120.22404277200008, 36.034996252000042],
          [120.22404107700004, 36.034997215000033],
          [120.22403856000005, 36.034997629000031],
          [120.22403646100008, 36.034997575000034],
          [120.22403442400002, 36.034997066000074],
          [120.22403284500001, 36.034995976000062],
          [120.2240315790001, 36.034994822000044],
          [120.2240268490001, 36.034990894000032],
          [120.22363585300002, 36.034484465000048]
        ],
        [
          [120.22458148800001, 36.035680269000068],
          [120.22456576100001, 36.035687609000036],
          [120.22413960600011, 36.035137586000076],
          [120.22415020400001, 36.035132216000079],
          [120.22415485200008, 36.03512986000004],
          [120.22415647300011, 36.035129039000026],
          [120.22458179300008, 36.035680128000024],
          [120.22458148800001, 36.035680269000068]
        ],
        [
          [120.22414047200004, 36.035120463000055],
          [120.22414037800002, 36.035120599000038],
          [120.22413865900012, 36.035121939000078],
          [120.2241361670001, 36.035122859000069],
          [120.22413355000003, 36.035123010000063],
          [120.2241307490001, 36.035122315000024],
          [120.22412909900004, 36.035121350000054],
          [120.2241276960001, 36.035119891000079],
          [120.22412676700003, 36.035118215000068],
          [120.22412657600012, 36.035116967000079],
          [120.22412684000005, 36.035115861000065],
          [120.22412721500007, 36.035114746000033],
          [120.22412795200012, 36.035113550000062],
          [120.22412887500002, 36.035112568000045],
          [120.22413024800005, 36.035111694000079],
          [120.2241313940001, 36.035111191000055],
          [120.2241326620001, 36.035110878000069],
          [120.22413412600008, 36.035110730000042],
          [120.22413544300002, 36.035110793000058],
          [120.22413677300005, 36.03511099800005],
          [120.22413809500006, 36.03511153900007],
          [120.22413954600006, 36.035112358000049],
          [120.22414060000006, 36.035113422000052],
          [120.22414123800002, 36.035114347000047],
          [120.22414176200004, 36.035115667000071],
          [120.22414190900008, 36.035116908000077],
          [120.22414137800001, 36.035119147000046],
          [120.22414047200004, 36.035120463000055]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 789,
      "bh": "0302",
      "mc": "小港池6号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.017462039840915967,
      "shape_Area": 2.5930525242892761e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22406716600005, 36.036089858000025],
          [120.22400886200012, 36.03601460200008],
          [120.22359518000007, 36.035480641000049],
          [120.22358889400005, 36.035472525000046],
          [120.22280305700008, 36.034458177000033],
          [120.22280521000005, 36.034453462000045],
          [120.22278424900003, 36.034431062000067],
          [120.22275054500005, 36.034397656000067],
          [120.22267656400004, 36.034299489000034],
          [120.2226860720001, 36.034294762000059],
          [120.2226765690001, 36.034282149000035],
          [120.2222214630001, 36.034289259000047],
          [120.2222570460001, 36.034515142000032],
          [120.22228736700004, 36.034636705000025],
          [120.22233753300009, 36.034702128000049],
          [120.22234517400011, 36.03471227700004],
          [120.2223295440001, 36.034720697000068],
          [120.22232151300011, 36.034710266000047],
          [120.22227054500001, 36.034644069000024],
          [120.22224250000011, 36.034536268000068],
          [120.22223026200004, 36.034520608000037],
          [120.22226743400006, 36.034646308000049],
          [120.22271843900012, 36.035231217000046],
          [120.22376498900007, 36.036581412000032],
          [120.22472206800001, 36.037810572000069],
          [120.22473846800006, 36.037802138000075],
          [120.2250063780001, 36.038148892000038],
          [120.22502688400004, 36.038165876000051],
          [120.2250840910001, 36.038188079000065],
          [120.22507897700007, 36.038201270000059],
          [120.22509818100002, 36.038206007000042],
          [120.22536398000011, 36.03827158100006],
          [120.22552859600012, 36.038299019000078],
          [120.22559324500003, 36.038285033000079],
          [120.22569095200004, 36.038234979000038],
          [120.2256747890001, 36.038215532000038],
          [120.22570473700011, 36.038197965000052],
          [120.22559682600001, 36.03805858000004],
          [120.22559133900006, 36.038057116000061],
          [120.22507919000009, 36.037398944000074],
          [120.22507330100007, 36.037391375000027],
          [120.22458932100005, 36.036769391000064],
          [120.2246015180001, 36.036762688000067],
          [120.22459566500004, 36.036755118000031],
          [120.22458359600012, 36.036761477000027],
          [120.2240732140001, 36.036097665000057],
          [120.22406716600005, 36.036089858000025]
        ],
        [
          [120.22250698400001, 36.034952734000058],
          [120.22252441300009, 36.034945196000024],
          [120.22312347500008, 36.035719208000046],
          [120.22310764500003, 36.035727119000057],
          [120.22250698400001, 36.034952734000058]
        ],
        [
          [120.22352548000003, 36.03623800500003],
          [120.22362554200004, 36.036367061000078],
          [120.22360912700003, 36.03637621300004],
          [120.22322434600005, 36.035881369000037],
          [120.22324150700001, 36.035871746000055],
          [120.22352548000003, 36.03623800500003]
        ],
        [
          [120.2245930580001, 36.037643761000027],
          [120.22423030200002, 36.037176868000074],
          [120.22424857800002, 36.037168217000044],
          [120.22460873000011, 36.037634840000067],
          [120.2245930580001, 36.037643761000027]
        ],
        [
          [120.22410661200001, 36.037017112000058],
          [120.22373490600012, 36.036537920000058],
          [120.22375245800004, 36.03652939400007],
          [120.22412194500009, 36.037009245000036],
          [120.22410661200001, 36.037017112000058]
        ],
        [
          [120.22423047300003, 36.037164496000059],
          [120.22423178300005, 36.037163984000074],
          [120.22423423500004, 36.037163308000061],
          [120.22423628800004, 36.037163138000039],
          [120.22423806100005, 36.037163553000028],
          [120.22423965600001, 36.03716451400004],
          [120.22424046700007, 36.037165306000077],
          [120.22424086800004, 36.037167414000066],
          [120.22424094100006, 36.037168841000039],
          [120.22424017800006, 36.037170422000031],
          [120.22423934800008, 36.037171425000054],
          [120.22423795400005, 36.037172217000034],
          [120.22423573200001, 36.03717258100005],
          [120.22423386700007, 36.037172534000035],
          [120.22423213100001, 36.037172101000067],
          [120.22423074900007, 36.037171145000059],
          [120.22422965400006, 36.03717014700004],
          [120.22422916000005, 36.037168942000051],
          [120.22422914500009, 36.037167723000039],
          [120.22422935400004, 36.037166214000024],
          [120.22423047300003, 36.037164496000059]
        ],
        [
          [120.22233562800011, 36.034719212000027],
          [120.22233693800001, 36.034718699000052],
          [120.22233938900001, 36.034718024000028],
          [120.22234144300012, 36.034717854000064],
          [120.22234321600001, 36.034718269000052],
          [120.22234481100008, 36.034719230000064],
          [120.22234562200003, 36.034720022000045],
          [120.22234602300011, 36.034722130000034],
          [120.22234609600002, 36.034723556000074],
          [120.22234533200003, 36.034725138000056],
          [120.22234450200006, 36.034726140000032],
          [120.22234310800002, 36.034726932000069],
          [120.22234088700009, 36.034727297000074],
          [120.22233902200003, 36.03472725000006],
          [120.22233728600008, 36.034726816000045],
          [120.22233590400003, 36.034725862000073],
          [120.22233480800003, 36.034724862000076],
          [120.22233431500001, 36.034723658000075],
          [120.22233430000006, 36.034722439000063],
          [120.22233450900001, 36.034720930000049],
          [120.22233562800011, 36.034719212000027]
        ],
        [
          [120.2236180970001, 36.03637234100006],
          [120.22361940600001, 36.036371829000075],
          [120.2236218590001, 36.036371153000061],
          [120.22362391200011, 36.03637098300004],
          [120.22362568500012, 36.036371398000028],
          [120.22362727900008, 36.03637235900004],
          [120.22362809100002, 36.036373151000078],
          [120.2236284920001, 36.036375259000067],
          [120.22362856500001, 36.03637668500005],
          [120.22362780200001, 36.036378267000032],
          [120.22362697100004, 36.036379269000065],
          [120.22362557800011, 36.036380062000035],
          [120.22362335600008, 36.036380426000051],
          [120.22362149000003, 36.036380378000047],
          [120.22361975500007, 36.036379945000078],
          [120.22361837200003, 36.03637899000006],
          [120.22361727700002, 36.036377992000041],
          [120.22361678400011, 36.036376787000052],
          [120.22361676900005, 36.03637556700005],
          [120.22361697800011, 36.036374059000025],
          [120.2236180970001, 36.03637234100006]
        ],
        [
          [120.22250643200005, 36.034940689000052],
          [120.22250774300005, 36.034940177000067],
          [120.22251019400005, 36.034939501000053],
          [120.22251224800004, 36.034939331000032],
          [120.22251402200004, 36.034939746000077],
          [120.22251561500002, 36.034940708000079],
          [120.22251642600008, 36.03494149900007],
          [120.22251682700005, 36.034943607000059],
          [120.22251690000007, 36.034945033000042],
          [120.22251613700007, 36.034946615000024],
          [120.22251530700009, 36.034947618000047],
          [120.22251391300006, 36.034948409000037],
          [120.22251169100002, 36.034948775000032],
          [120.22250982600008, 36.034948727000028],
          [120.22250809000002, 36.03494829300007],
          [120.22250670900007, 36.034947338000052],
          [120.22250561300007, 36.034946339000044],
          [120.22250511900006, 36.034945135000044],
          [120.22250510400011, 36.034943916000032],
          [120.22250531400005, 36.034942407000074],
          [120.22250643200005, 36.034940689000052]
        ],
        [
          [120.22460020500012, 36.03764026500005],
          [120.22460151400003, 36.037639752000075],
          [120.22460396700001, 36.037639076000062],
          [120.22460602000001, 36.037638906000041],
          [120.22460779300002, 36.037639321000029],
          [120.22460938800009, 36.03764028300003],
          [120.22461019900004, 36.037641074000078],
          [120.22461060000001, 36.037643182000068],
          [120.22461067300003, 36.03764460900004],
          [120.22460991000003, 36.037646190000032],
          [120.22460907900006, 36.037647193000055],
          [120.22460768600001, 36.037647985000035],
          [120.22460546400009, 36.03764835000004],
          [120.22460359800004, 36.037648303000026],
          [120.22460186300009, 36.037647869000068],
          [120.22460048100004, 36.037646914000049],
          [120.22459938600002, 36.037645915000041],
          [120.22459889200002, 36.037644711000041],
          [120.22459887700006, 36.037643492000029],
          [120.22459908600001, 36.037641983000071],
          [120.22460020500012, 36.03764026500005]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 790,
      "bh": "0302",
      "mc": "前方南堆场3",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.005653970848154429,
      "shape_Area": 1.5275391291002135e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21845283200003, 36.024476370000059],
          [120.21844161600006, 36.024469949000036],
          [120.21844318500007, 36.024468338000077],
          [120.21845274100008, 36.02445853200004],
          [120.21845932100007, 36.024451986000031],
          [120.2184540830001, 36.024448512000049],
          [120.21833010800003, 36.024314602000061],
          [120.21825718200012, 36.024211978000039],
          [120.21825751600011, 36.024217811000028],
          [120.21825802700005, 36.024222143000031],
          [120.21825751300003, 36.024222182000074],
          [120.21825869400004, 36.024232379000068],
          [120.21825890900004, 36.02423458100003],
          [120.21825782800011, 36.024237172000028],
          [120.21825610200005, 36.024238757000035],
          [120.21825234300002, 36.024240046000045],
          [120.21825080400004, 36.024240077000059],
          [120.21824307800011, 36.024240517000067],
          [120.21824342100001, 36.024244486000043],
          [120.2180060820001, 36.024254055000029],
          [120.21757094300006, 36.024270912000077],
          [120.21716967200007, 36.024285851000059],
          [120.21713661100011, 36.02429735100003],
          [120.21693438800003, 36.024499947000038],
          [120.21835496100005, 36.025440042000071],
          [120.21849677400007, 36.025534031000063],
          [120.21859410900004, 36.025440476000028],
          [120.21868208400008, 36.025495797000076],
          [120.21883663800008, 36.025345820000041],
          [120.21884690500008, 36.025352785000052],
          [120.21885192900004, 36.025347897000074],
          [120.21901468300007, 36.025190476000034],
          [120.21900480000011, 36.025183579000043],
          [120.21900945600009, 36.025178502000074],
          [120.2191440360001, 36.025047001000075],
          [120.21921280600009, 36.024979228000063],
          [120.21909403200004, 36.024900838000065],
          [120.21908336800004, 36.024895066000056],
          [120.21908658300003, 36.024891895000053],
          [120.21908397600009, 36.024890149000043],
          [120.21908053900006, 36.024889226000028],
          [120.21907898600011, 36.024888172000033],
          [120.21907770100006, 36.024886602000038],
          [120.21907701700002, 36.024884371000041],
          [120.21907737100003, 36.024882142000024],
          [120.21907828800011, 36.024880608000046],
          [120.21908010200002, 36.024879074000069],
          [120.21908360000009, 36.024875572000042],
          [120.21893154600002, 36.024775337000051],
          [120.21892705800008, 36.024779829000067],
          [120.21892533300002, 36.024781413000028],
          [120.21892157400009, 36.024782703000028],
          [120.21892003500011, 36.024782734000041],
          [120.21891659900007, 36.024781810000036],
          [120.21890918700001, 36.024777234000055],
          [120.21890832100007, 36.024778161000029],
          [120.21889764900004, 36.02477093400006],
          [120.21845283200003, 36.024476370000059]
        ],
        [
          [120.21843687900002, 36.024464283000043],
          [120.21843532600008, 36.024463230000038],
          [120.21843404000003, 36.024461659000053],
          [120.21843335700009, 36.024459429000046],
          [120.21843371200009, 36.024457200000029],
          [120.21843462800007, 36.024455666000051],
          [120.21843644100011, 36.024454132000074],
          [120.21843914300007, 36.024453117000064],
          [120.21844233900003, 36.024453060000042],
          [120.21844534000002, 36.024454118000051],
          [120.21844681800007, 36.024455268000054],
          [120.21844820500007, 36.024457509000058],
          [120.21844842000007, 36.024459711000077],
          [120.21844734000001, 36.024462303000064],
          [120.21844561300009, 36.024463887000024],
          [120.21844185500004, 36.024465177000025],
          [120.21844031600006, 36.024465207000048],
          [120.21843687900002, 36.024464283000043]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 793,
      "bh": "0302",
      "mc": "小港池7号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.012923195250146315,
      "shape_Area": 2.9325339282524939e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22312232800004, 36.03589697700005],
          [120.22311769200007, 36.035890982000069],
          [120.22267898300004, 36.035323780000056],
          [120.22267105300011, 36.035313527000028],
          [120.22267376200011, 36.035312055000077],
          [120.22266424000009, 36.035299376000069],
          [120.2225596510001, 36.035164718000033],
          [120.22255094100001, 36.035153364000053],
          [120.2225477070001, 36.035154453000075],
          [120.22254966500009, 36.035156979000078],
          [120.2225349040001, 36.035164656000063],
          [120.22224520300006, 36.034790800000053],
          [120.22220156100002, 36.034734479000065],
          [120.22217812100007, 36.034745341000075],
          [120.22215082300011, 36.034711032000075],
          [120.22216566300006, 36.034703110000066],
          [120.22216087000004, 36.034696826000072],
          [120.22218095200003, 36.034686726000075],
          [120.2221823540001, 36.034687147000056],
          [120.22218818300007, 36.034684365000032],
          [120.22208937400001, 36.034558992000029],
          [120.22205013900009, 36.034291935000056],
          [120.22205446700002, 36.034291868000025],
          [120.22203824400003, 36.034179878000032],
          [120.22200405600006, 36.034098854000035],
          [120.22199725400003, 36.034098861000075],
          [120.22199638100005, 36.034100991000059],
          [120.22199142300008, 36.034104014000036],
          [120.22198562700009, 36.034106196000039],
          [120.22194357300009, 36.034118043000035],
          [120.22190339100007, 36.03415078900008],
          [120.22190360900004, 36.034210298000062],
          [120.22190362400011, 36.034566448000078],
          [120.22192493900002, 36.034566167000037],
          [120.22193279300006, 36.034566085000051],
          [120.22193279800001, 36.034569794000049],
          [120.22193340100011, 36.034883137000065],
          [120.22193346500001, 36.034947514000066],
          [120.22193313900004, 36.035237729000073],
          [120.2219261250001, 36.035264562000066],
          [120.22192532200006, 36.035541290000026],
          [120.22192605800001, 36.035544212000048],
          [120.22301312800005, 36.036721164000028],
          [120.22304034900003, 36.037085084000068],
          [120.22387502900006, 36.038039062000053],
          [120.22398526500001, 36.038062422000053],
          [120.22398076400009, 36.038077981000072],
          [120.2249819430001, 36.038292351000052],
          [120.22498969700007, 36.038294011000062],
          [120.22488490900002, 36.038156306000076],
          [120.22436444900006, 36.037484771000038],
          [120.22425570900009, 36.037345330000051],
          [120.2237929910001, 36.036747315000071],
          [120.22368832100005, 36.03661229800008],
          [120.2236785340001, 36.036616278000054],
          [120.22367127600012, 36.036607334000053],
          [120.22366988200008, 36.036608126000033],
          [120.22366766000005, 36.036608492000028],
          [120.22366579400011, 36.036608444000024],
          [120.22366405900004, 36.036608010000066],
          [120.2236626780001, 36.036607055000047],
          [120.22366158200009, 36.036606056000039],
          [120.22366108800009, 36.036604852000039],
          [120.22366107300002, 36.036603633000027],
          [120.22366128200008, 36.036602124000069],
          [120.22366240100007, 36.036600406000048],
          [120.22366371100009, 36.036599893000073],
          [120.22366616300008, 36.036599218000049],
          [120.22366821600008, 36.036599048000028],
          [120.22366998900009, 36.036599462000027],
          [120.22367158400004, 36.036600424000028],
          [120.22367182300002, 36.036600657000065],
          [120.22326589500005, 36.036075769000036],
          [120.22326184700012, 36.03607770800005],
          [120.22366332100012, 36.036594879000063],
          [120.22366212200006, 36.036595398000031],
          [120.22364798600006, 36.036601526000027],
          [120.22324006600002, 36.036075742000037],
          [120.22325058500007, 36.03606989900004],
          [120.22325421900007, 36.036067880000076],
          [120.22325492900006, 36.036068796000052],
          [120.22325856300006, 36.036066822000066],
          [120.22324373700008, 36.036046376000058],
          [120.22313704700002, 36.035909466000078],
          [120.22312758500004, 36.035897565000027],
          [120.2231245480001, 36.035899116000053],
          [120.22312232800004, 36.03589697700005]
        ],
        [
          [120.22269424800004, 36.035362244000055],
          [120.22267532400008, 36.035372118000055],
          [120.22265765900011, 36.035349783000072],
          [120.22267658300007, 36.035339909000072],
          [120.22269424800004, 36.035362244000055]
        ],
        [
          [120.22265856200011, 36.035339509000039],
          [120.22265351600004, 36.035333023000078],
          [120.22267266900008, 36.035322803000042],
          [120.22267778700007, 36.035328882000044],
          [120.22265856200011, 36.035339509000039]
        ],
        [
          [120.22312278800007, 36.035905286000059],
          [120.22312409800008, 36.035904774000073],
          [120.22312654900009, 36.03590409800006],
          [120.22312860300008, 36.035903929000028],
          [120.22313037600009, 36.035904343000027],
          [120.22313197100004, 36.035905305000028],
          [120.22313278200011, 36.035906096000076],
          [120.22313318300007, 36.035908204000066],
          [120.2231332560001, 36.035909630000049],
          [120.2231324920001, 36.03591121200003],
          [120.22313166300012, 36.035912215000053],
          [120.22313026800009, 36.035913007000033],
          [120.22312804700005, 36.035913372000039],
          [120.22312618100011, 36.035913324000035],
          [120.22312444600004, 36.035912890000077],
          [120.22312306400011, 36.035911936000048],
          [120.2231219680001, 36.03591093600005],
          [120.2231214740001, 36.03590973200005],
          [120.22312146000002, 36.035908513000038],
          [120.22312166800009, 36.03590700400008],
          [120.22312278800007, 36.035905286000059]
        ],
        [
          [120.22324167300008, 36.036058008000055],
          [120.22324298300009, 36.036057496000069],
          [120.22324543600007, 36.036056820000056],
          [120.22324748900007, 36.036056650000035],
          [120.22324926300007, 36.03605706500008],
          [120.22325085600005, 36.036058026000035],
          [120.2232516680001, 36.036058818000072],
          [120.22325206900007, 36.036060926000061],
          [120.22325214200009, 36.036062352000044],
          [120.2232513780001, 36.036063934000026],
          [120.22325054900011, 36.036064936000059],
          [120.22324915400009, 36.036065729000029],
          [120.22324693200005, 36.036066093000045],
          [120.22324506700011, 36.036066045000041],
          [120.22324333300003, 36.036065612000073],
          [120.2232419500001, 36.036064657000054],
          [120.2232408540001, 36.036063659000035],
          [120.22324036000009, 36.036062454000046],
          [120.22324034500002, 36.036061234000044],
          [120.22324055500007, 36.036059726000076],
          [120.22324167300008, 36.036058008000055]
        ],
        [
          [120.22266702800005, 36.035308323000038],
          [120.22266706500011, 36.035309049000034],
          [120.22266630100012, 36.035310631000073],
          [120.22266547200002, 36.035311634000038],
          [120.2226640770001, 36.035312426000075],
          [120.22266185600006, 36.035312791000024],
          [120.22265999000001, 36.035312743000077],
          [120.22265825500006, 36.035312309000062],
          [120.22265687300001, 36.035311354000044],
          [120.22265577700011, 36.035310355000036],
          [120.22265528300011, 36.035309151000035],
          [120.22265526900003, 36.03530793200008],
          [120.22265547800009, 36.035306423000065],
          [120.22265659700008, 36.035304705000044],
          [120.2226579070001, 36.035304193000059],
          [120.2226603580001, 36.035303517000045],
          [120.22266241200009, 36.035303347000024],
          [120.2226641850001, 36.03530376100008],
          [120.22266578000006, 36.035304724000071],
          [120.22266659100001, 36.035305515000061],
          [120.22266699200009, 36.035307622000062],
          [120.22266702800005, 36.035308323000038]
        ],
        [
          [120.22254546200008, 36.035160676000032],
          [120.2225467720001, 36.035160163000057],
          [120.2225492230001, 36.035159488000033],
          [120.22255127800008, 36.035159318000069],
          [120.22255305100009, 36.035159733000057],
          [120.22255464500006, 36.035160694000069],
          [120.22255545600001, 36.03516148600005],
          [120.22255585700009, 36.035163594000039],
          [120.22255592900001, 36.035165020000079],
          [120.22255516600001, 36.035166602000061],
          [120.22255433700002, 36.035167604000037],
          [120.22255294200011, 36.035168396000074],
          [120.22255072000007, 36.035168761000079],
          [120.22254885500001, 36.035168714000065],
          [120.22254712000006, 36.03516828000005],
          [120.22254573800001, 36.035167326000078],
          [120.22254464200012, 36.035166326000024],
          [120.22254414800011, 36.03516512200008],
          [120.22254413400003, 36.035163902000079],
          [120.22254434400008, 36.035162394000054],
          [120.22254546200008, 36.035160676000032]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 794,
      "bh": "0302",
      "mc": "大护坡堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.02881498817908907,
      "shape_Area": 5.1527475308656821e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21043931600002, 36.030119515000024],
          [120.21046869100007, 36.030135696000059],
          [120.21051898000007, 36.03016339900006],
          [120.21055230000002, 36.03018086700007],
          [120.21088171100007, 36.03037751200003],
          [120.21154930800003, 36.030721092000078],
          [120.21156642100004, 36.030730435000066],
          [120.21269066900004, 36.031316848000074],
          [120.21339694700009, 36.031679159000078],
          [120.21360196100011, 36.031784119000065],
          [120.21361165000008, 36.03177531700004],
          [120.21419959700006, 36.032053710000071],
          [120.21429676500009, 36.032106057000078],
          [120.21428718600009, 36.032118306000029],
          [120.21558104900009, 36.032795383000064],
          [120.21634250500006, 36.03318902500007],
          [120.21672493800008, 36.033386144000076],
          [120.21709198300005, 36.033574535000071],
          [120.21719001400004, 36.033623911000063],
          [120.21754900100007, 36.03381039900006],
          [120.21765774300002, 36.033868429000051],
          [120.21769444500001, 36.033889757000054],
          [120.21772894500009, 36.033843823000041],
          [120.21777470800009, 36.033866462000049],
          [120.21784085200011, 36.033900090000031],
          [120.21806873300011, 36.034015948000047],
          [120.2180967700001, 36.034017267000024],
          [120.21844348000002, 36.034032883000066],
          [120.21859597500008, 36.034030593000068],
          [120.21861886700003, 36.034031069000036],
          [120.21863458700011, 36.034031004000042],
          [120.21864979800011, 36.034025886000052],
          [120.21865919800007, 36.034024743000032],
          [120.21867705500006, 36.034017382000059],
          [120.21870836200003, 36.034008529000062],
          [120.21872073700001, 36.034004776000074],
          [120.21873654700005, 36.033996235000075],
          [120.21780537000006, 36.033515039000065],
          [120.21727056400005, 36.033238665000056],
          [120.21712383100009, 36.033162837000077],
          [120.21592942900008, 36.032545584000047],
          [120.21579459200007, 36.032475900000065],
          [120.21101375300009, 36.030004991000055],
          [120.21096440200006, 36.02997948400008],
          [120.21096320700008, 36.029978866000079],
          [120.21091224700001, 36.029952527000034],
          [120.21091124600002, 36.029952009000056],
          [120.21089895700004, 36.02996762600003],
          [120.21079930600001, 36.02991670800003],
          [120.21081349800011, 36.029900330000032],
          [120.21077894000007, 36.029882470000075],
          [120.2107560610001, 36.029911404000075],
          [120.21068436700011, 36.029874003000032],
          [120.21070646700002, 36.02984605100005],
          [120.21068966100006, 36.029837367000027],
          [120.21027339600005, 36.029622269000072],
          [120.20930867400011, 36.029123754000068],
          [120.20810515500011, 36.028501821000077],
          [120.20808263600009, 36.028530259000036],
          [120.20801039200001, 36.028492511000024],
          [120.20803845000012, 36.028457079000077],
          [120.20762264000007, 36.028241682000044],
          [120.20762600300009, 36.02823685900006],
          [120.20745870500002, 36.02815178000003],
          [120.20745530600004, 36.028155517000073],
          [120.20640217800008, 36.027611333000038],
          [120.20635324000011, 36.027627061000032],
          [120.20625672200003, 36.027683952000075],
          [120.20626715500009, 36.02769745300003],
          [120.20612542900005, 36.027824224000028],
          [120.2060732220001, 36.027892370000075],
          [120.20615305600006, 36.027933619000066],
          [120.20637127600003, 36.028028734000031],
          [120.20643525000003, 36.028063664000058],
          [120.20713654500003, 36.028434845000049],
          [120.20765436900001, 36.028709302000038],
          [120.20812613300006, 36.028953041000079],
          [120.20814338200012, 36.028928774000065],
          [120.20814519100009, 36.02892736900003],
          [120.20814907600004, 36.028927082000052],
          [120.20855253400009, 36.029138653000075],
          [120.2085618320001, 36.029128854000078],
          [120.2085672610001, 36.02912526800003],
          [120.20857542200008, 36.029125832000034],
          [120.20910379500003, 36.029396314000053],
          [120.20975144100009, 36.02974636700003],
          [120.21015510700011, 36.029965343000072],
          [120.21043931600002, 36.030119515000024]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 795,
      "bh": "0302",
      "mc": "煤7号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0071297401406830241,
      "shape_Area": 1.3507381377025721e-6
    },
    "geometry": {
      "rings": [
        [
          [120.20999143200004, 36.028474708000033],
          [120.2097761440001, 36.028363432000049],
          [120.20810949100007, 36.027501960000052],
          [120.20810919700011, 36.027502343000037],
          [120.20803795200004, 36.027595189000067],
          [120.20802050900011, 36.027615184000069],
          [120.20798544600007, 36.027661075000026],
          [120.20794935100002, 36.027707336000049],
          [120.20794441100008, 36.027714372000048],
          [120.20792384800006, 36.027732893000064],
          [120.20881370400002, 36.028296305000026],
          [120.20949686100005, 36.028738911000062],
          [120.20953149400009, 36.028761349000035],
          [120.20990143500001, 36.029001023000035],
          [120.21006109100006, 36.029088483000066],
          [120.21059089900007, 36.029376007000053],
          [120.21065322200002, 36.029293304000078],
          [120.21073286700005, 36.029187612000044],
          [120.21079283000006, 36.029110022000054],
          [120.21081493400004, 36.029078596000033],
          [120.21081647300002, 36.02907880600003],
          [120.21081826800003, 36.029078650000031],
          [120.21082043400008, 36.029077800000039],
          [120.21082178200004, 36.029076664000058],
          [120.21082263200003, 36.029075231000036],
          [120.21082284000011, 36.029073151000034],
          [120.21082190300001, 36.029071077000026],
          [120.21082046300012, 36.029069811000056],
          [120.21088250500009, 36.028978945000063],
          [120.21088467200002, 36.02897809500007],
          [120.2108860190001, 36.028976959000033],
          [120.21088686900009, 36.028975526000067],
          [120.21088707700005, 36.028973446000066],
          [120.21088614000007, 36.028971372000058],
          [120.21088516500004, 36.028970514000036],
          [120.21088862700003, 36.028964032000033],
          [120.21089859600011, 36.02894784700004],
          [120.2109020580001, 36.028940723000062],
          [120.21006214400006, 36.028506793000076],
          [120.21005625300006, 36.028514261000055],
          [120.2099881800001, 36.028478832000076],
          [120.20999143200004, 36.028474708000033]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 796,
      "bh": "0302",
      "mc": "20万8号西堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.007451180793593787,
      "shape_Area": 1.7933198196721412e-6
    },
    "geometry": {
      "rings": [
        [
          [120.20906712800002, 36.026476616000025],
          [120.20904332700002, 36.02647887300003],
          [120.20904354600009, 36.026480400000025],
          [120.2087741680001, 36.026510400000063],
          [120.20861145600009, 36.026529233000076],
          [120.20837539700005, 36.026555540000061],
          [120.2083746620001, 36.026551138000059],
          [120.20811978300003, 36.026579188000028],
          [120.2081207330001, 36.026584875000026],
          [120.20801010600007, 36.026595612000051],
          [120.20791125000005, 36.026607075000072],
          [120.20780771200009, 36.026618498000062],
          [120.2076810320001, 36.026633927000034],
          [120.20746854900005, 36.026904821000073],
          [120.20824801600008, 36.027305913000077],
          [120.20848251300004, 36.027426011000045],
          [120.20858321700007, 36.02747852400006],
          [120.20858378900004, 36.027477648000058],
          [120.20858449400009, 36.027476956000044],
          [120.20858551200001, 36.027476298000067],
          [120.20858660700003, 36.027475864000053],
          [120.20858751100002, 36.027475664000065],
          [120.20858875700003, 36.027475585000047],
          [120.20859043900009, 36.02747583200005],
          [120.20859172600001, 36.027476339000032],
          [120.20859283700008, 36.027477102000034],
          [120.20859342100005, 36.027477972000042],
          [120.20859402600001, 36.027478706000068],
          [120.20859435800003, 36.027480163000064],
          [120.20859423600007, 36.027481249000061],
          [120.20859382900005, 36.027482245000044],
          [120.20859312800008, 36.027483176000032],
          [120.20859243200005, 36.027483732000064],
          [120.20887927400008, 36.027631142000075],
          [120.2089091790001, 36.027646078000032],
          [120.20892077400003, 36.02765164200008],
          [120.2090545530001, 36.027720448000025],
          [120.20906689100002, 36.02772531800008],
          [120.20912246800003, 36.027747344000034],
          [120.20922039200002, 36.027782343000069],
          [120.20937351500004, 36.027837221000027],
          [120.20951847600008, 36.027889548000076],
          [120.20961218400009, 36.027923097000041],
          [120.2096170850001, 36.027925117000052],
          [120.20962784900007, 36.027930696000055],
          [120.20967671400001, 36.027955829000064],
          [120.20973429100002, 36.02798477400006],
          [120.2097373790001, 36.027980721000063],
          [120.20973937300005, 36.027978104000056],
          [120.20976791600003, 36.027940641000043],
          [120.21006997500001, 36.028092488000027],
          [120.21006760500006, 36.02809559800005],
          [120.21010619300012, 36.028115203000027],
          [120.21011073600005, 36.028112527000076],
          [120.21020760500005, 36.027989461000061],
          [120.21035964400005, 36.027796152000064],
          [120.21037509600001, 36.027776419000077],
          [120.21029789600004, 36.027698599000075],
          [120.20977041800006, 36.027426655000056],
          [120.20976860000007, 36.027428959000076],
          [120.20976001400004, 36.027423981000027],
          [120.2095695910001, 36.027325279000024],
          [120.20955961600009, 36.027317912000058],
          [120.20898880300001, 36.027022789000057],
          [120.20898994100003, 36.027018517000045],
          [120.20884000800004, 36.026943679000055],
          [120.20887769900003, 36.026890321000053],
          [120.20888319300002, 36.026882942000043],
          [120.20889753900008, 36.026861000000054],
          [120.20896052300009, 36.026769522000052],
          [120.20900423800003, 36.026705707000076],
          [120.20902646700006, 36.026671426000064],
          [120.20908043200006, 36.026474962000066],
          [120.20906712800002, 36.026476616000025]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 797,
      "bh": "0302",
      "mc": "20万8号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.005735101268878778,
      "shape_Area": 1.8680280016172193e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21123545500006, 36.026650826000036],
          [120.21121928500008, 36.02664238400007],
          [120.21126784300009, 36.026581015000033],
          [120.21125724400008, 36.026576348000049],
          [120.2110182450001, 36.026451948000044],
          [120.21083192700007, 36.026357739000048],
          [120.2107094270001, 36.026295596000068],
          [120.2100813080001, 36.02636532300005],
          [120.20980775400005, 36.026395674000071],
          [120.2092749410001, 36.026456470000028],
          [120.20926666900004, 36.026469646000066],
          [120.20926399500001, 36.02647373700006],
          [120.20926095100003, 36.026478392000058],
          [120.20916825400002, 36.02661837100004],
          [120.20901367400006, 36.026848478000034],
          [120.2090111120001, 36.026922046000038],
          [120.20901082600005, 36.026930275000041],
          [120.20899997300012, 36.02692976600008],
          [120.20901799500007, 36.026939716000072],
          [120.20908647100009, 36.026975788000072],
          [120.20921674200008, 36.027043648000074],
          [120.20936324400009, 36.027118518000066],
          [120.2095325460001, 36.02720654400008],
          [120.20960238400005, 36.027242556000033],
          [120.20960389400011, 36.027241220000064],
          [120.20962339400012, 36.027250423000055],
          [120.20963701400001, 36.027257545000055],
          [120.20980134600006, 36.027343479000024],
          [120.20981098600009, 36.027348521000079],
          [120.21038084300005, 36.027643011000066],
          [120.21037503700006, 36.027645893000056],
          [120.21036988500009, 36.027646963000052],
          [120.21037544400008, 36.027649813000039],
          [120.21036991700009, 36.027657214000044],
          [120.21044602200004, 36.027696541000068],
          [120.21045669800003, 36.027682200000072],
          [120.21045234600001, 36.027679507000073],
          [120.21045055400009, 36.027673898000046],
          [120.21045274900007, 36.027668635000055],
          [120.21050581200006, 36.027603961000068],
          [120.21059226300008, 36.027493324000034],
          [120.21078265900007, 36.027249619000031],
          [120.21088107300011, 36.027124068000035],
          [120.2112186380001, 36.026695686000039],
          [120.21124180000004, 36.026665863000062],
          [120.21122889000003, 36.026659123000059],
          [120.21123545500006, 36.026650826000036]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 798,
      "bh": "0302",
      "mc": "20万5号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.019787409644694453,
      "shape_Area": 3.6882927011973837e-6
    },
    "geometry": {
      "rings": [
        [
          [120.20581884100011, 36.026240087000076],
          [120.20582968500003, 36.026239200000077],
          [120.20590491900009, 36.026235744000076],
          [120.2059975730001, 36.026224589000037],
          [120.20599596800002, 36.026215793000063],
          [120.20598905800011, 36.026177920000066],
          [120.20631927200009, 36.026140466000072],
          [120.20631926900012, 36.026140459000032],
          [120.2063127880001, 36.026103156000033],
          [120.20631268000011, 36.026095905000034],
          [120.20631596800001, 36.026093143000026],
          [120.20632574800004, 36.026090477000025],
          [120.20688647000009, 36.026027201000034],
          [120.20689887200001, 36.02602580100006],
          [120.21435223500009, 36.025194385000077],
          [120.21488295400002, 36.025135165000052],
          [120.21489274700002, 36.025077038000063],
          [120.21489221400009, 36.025073392000024],
          [120.21489338300012, 36.025073260000056],
          [120.2149080690001, 36.024986099000046],
          [120.21489563200009, 36.024966061000043],
          [120.21487681000008, 36.024961547000032],
          [120.21480486700011, 36.024944123000068],
          [120.21471939000003, 36.024924145000057],
          [120.21451179700011, 36.024898378000046],
          [120.21445385700008, 36.024890120000066],
          [120.21442695300004, 36.024886285000036],
          [120.21432290900009, 36.024878098000045],
          [120.2142856590001, 36.024875166000072],
          [120.21423353400007, 36.024873396000032],
          [120.21417762100009, 36.02487149600006],
          [120.21367137300001, 36.024882175000073],
          [120.21336750500006, 36.024897822000071],
          [120.21315623400005, 36.024921369000026],
          [120.21315695800001, 36.024922533000051],
          [120.21315734000007, 36.024924717000033],
          [120.21315687600008, 36.024926664000077],
          [120.21315575800008, 36.024928331000069],
          [120.2131538970001, 36.024929759000031],
          [120.21315178100008, 36.024930571000027],
          [120.21314898900005, 36.024930819000076],
          [120.21314664100009, 36.024930380000058],
          [120.21314464400007, 36.024929426000028],
          [120.21314309500008, 36.024928058000057],
          [120.21314212200002, 36.024926436000044],
          [120.21314175100008, 36.024924587000044],
          [120.21314211800006, 36.024922579000076],
          [120.21283741800005, 36.024957984000025],
          [120.21283848200005, 36.024959693000028],
          [120.2128388640001, 36.024961879000045],
          [120.21283840000001, 36.024963826000032],
          [120.21283728200001, 36.024965493000025],
          [120.21283542100002, 36.024966920000054],
          [120.21283330500012, 36.02496773300004],
          [120.21283051300009, 36.024967981000032],
          [120.21282816600001, 36.02496754200007],
          [120.21282616800011, 36.024966588000041],
          [120.21282461900012, 36.02496522000007],
          [120.21282364600006, 36.024963597000067],
          [120.21282327500001, 36.024961749000056],
          [120.21282361600004, 36.024959884000054],
          [120.21241738200001, 36.025006123000026],
          [120.21228591400006, 36.025020237000035],
          [120.21215585800007, 36.025034649000077],
          [120.21179084700009, 36.025076219000027],
          [120.21123693800007, 36.025138223000056],
          [120.2112373110001, 36.025140391000036],
          [120.21123684700001, 36.02514233800008],
          [120.21123572900001, 36.025144005000072],
          [120.21123386700003, 36.025145433000034],
          [120.21123175200012, 36.02514624500003],
          [120.21122896000008, 36.025146494000069],
          [120.21122661200002, 36.025146054000061],
          [120.21122461500011, 36.025145101000078],
          [120.21122306600012, 36.02514373200006],
          [120.21122209300006, 36.025142110000047],
          [120.21122172200012, 36.025140261000047],
          [120.21093985500011, 36.025171617000069],
          [120.21094023700005, 36.02517380200004],
          [120.21093977300006, 36.025175748000038],
          [120.21093865400007, 36.025177417000066],
          [120.21093679300009, 36.025178844000038],
          [120.21093467700007, 36.025179655000045],
          [120.21093188500004, 36.025179904000026],
          [120.21092953900006, 36.025179464000075],
          [120.21092754000006, 36.025178511000036],
          [120.21092599100007, 36.025177143000064],
          [120.2109250200001, 36.025175520000062],
          [120.21092464700007, 36.025173672000051],
          [120.2109247520001, 36.02517309600006],
          [120.2109245370001, 36.02517312100008],
          [120.21054125300009, 36.025218476000077],
          [120.21017401900008, 36.025262877000046],
          [120.21017439900004, 36.025265076000039],
          [120.21017393500006, 36.025267023000026],
          [120.21017281600007, 36.025268691000065],
          [120.21017095500008, 36.025270117000048],
          [120.21016883800007, 36.025270930000033],
          [120.21016604800002, 36.025271179000072],
          [120.21016370000007, 36.025270738000074],
          [120.21016170300004, 36.025269786000024],
          [120.21016015400005, 36.025268417000063],
          [120.21015918100011, 36.02526679500005],
          [120.21015881000005, 36.02526494600005],
          [120.21015917700004, 36.025262938000026],
          [120.21015975800003, 36.025261832000069],
          [120.20984753500011, 36.025297348000038],
          [120.20984826300003, 36.025301576000061],
          [120.20943028600004, 36.025348600000029],
          [120.2094296460001, 36.025344883000059],
          [120.20931071000007, 36.02535841200006],
          [120.20931132700002, 36.025362001000076],
          [120.20894322300001, 36.025403264000033],
          [120.20894430300007, 36.025404988000048],
          [120.20894468500001, 36.025407174000065],
          [120.20894422100002, 36.025409120000063],
          [120.20894310300002, 36.025410788000045],
          [120.20894124200004, 36.025412215000074],
          [120.20893912600002, 36.025413026000024],
          [120.2089363340001, 36.025413275000062],
          [120.20893398600003, 36.025412835000054],
          [120.20893198900001, 36.025411882000071],
          [120.20893044000002, 36.025410513000054],
          [120.20892946700008, 36.025408891000041],
          [120.20892909600002, 36.02540704300003],
          [120.20892946400011, 36.025405035000063],
          [120.20893004400011, 36.025403930000039],
          [120.2089313350001, 36.025402515000053],
          [120.20893285700004, 36.02540153800004],
          [120.20864918500001, 36.025435208000033],
          [120.20865106100007, 36.025435730000027],
          [120.2086527140001, 36.02543662000005],
          [120.20865396300007, 36.025437733000047],
          [120.20865502700008, 36.025439444000028],
          [120.20865540900002, 36.025441628000067],
          [120.20865494500003, 36.025443575000054],
          [120.20865382600005, 36.025445242000046],
          [120.20865196500006, 36.025446670000065],
          [120.20864984900004, 36.025447482000061],
          [120.20864705800011, 36.025447731000042],
          [120.20864471100003, 36.025447291000035],
          [120.20864271300002, 36.025446338000052],
          [120.20864116400003, 36.025444969000034],
          [120.20864019200008, 36.025443347000078],
          [120.20863982000003, 36.025441498000077],
          [120.20864011900005, 36.025439863000031],
          [120.20849196600011, 36.025452442000073],
          [120.20819759900007, 36.02548666000007],
          [120.20794404500009, 36.025514625000028],
          [120.20764396100003, 36.025548365000077],
          [120.20764439000004, 36.025549055000056],
          [120.20764477200009, 36.025551240000027],
          [120.20764430800011, 36.025553186000025],
          [120.20764318900001, 36.025554854000063],
          [120.20764132800002, 36.025556281000036],
          [120.20763921100001, 36.025557093000032],
          [120.2076364190001, 36.02555734200007],
          [120.20763407300001, 36.025556902000062],
          [120.2076320760001, 36.025555948000033],
          [120.20763052700011, 36.025554580000062],
          [120.20762955400005, 36.025552958000048],
          [120.20762918300011, 36.025551109000048],
          [120.20762938300004, 36.025550014000032],
          [120.20737096400001, 36.025579235000066],
          [120.20737187200007, 36.025580693000052],
          [120.20737225400001, 36.025582879000069],
          [120.20737179000002, 36.025584826000056],
          [120.20737067200002, 36.025586493000048],
          [120.20736881000005, 36.025587920000078],
          [120.20736669400003, 36.025588731000028],
          [120.20736390200011, 36.025588980000066],
          [120.20736155500003, 36.025588540000058],
          [120.20735955800001, 36.025587587000075],
          [120.20735800900002, 36.025586218000058],
          [120.20735703600008, 36.025584596000044],
          [120.20735666500002, 36.025582748000033],
          [120.20735701900003, 36.02558080700004],
          [120.20735098000011, 36.02558149500004],
          [120.20685458500009, 36.025637624000069],
          [120.20684664800001, 36.025637697000036],
          [120.20681435200004, 36.025641938000035],
          [120.20673165400001, 36.025651397000047],
          [120.20660709900005, 36.025665736000064],
          [120.20647800800009, 36.025680439000041],
          [120.20631222300005, 36.025699394000071],
          [120.20617856600006, 36.025715171000058],
          [120.2061777450001, 36.025713851000035],
          [120.20617649500002, 36.025712737000049],
          [120.20617484100001, 36.025711848000071],
          [120.20617296600005, 36.025711326000078],
          [120.2061706610001, 36.025711225000066],
          [120.20616847500003, 36.025711658000034],
          [120.20616736200009, 36.025712111000075],
          [120.20616584000004, 36.025713087000042],
          [120.20616454900005, 36.025714502000028],
          [120.20616396900004, 36.025715607000052],
          [120.20590158500011, 36.025745111000049],
          [120.20589993100009, 36.025744222000071],
          [120.20589805500003, 36.025743700000078],
          [120.20589574900009, 36.025743598000076],
          [120.20589356500011, 36.025744032000034],
          [120.20589245100007, 36.025744484000029],
          [120.20589092900002, 36.025745461000042],
          [120.20588963900002, 36.025746876000028],
          [120.2055242350001, 36.025788383000076],
          [120.20551125100008, 36.02579051400005],
          [120.20549959900006, 36.025792392000028],
          [120.20548897300012, 36.025794715000075],
          [120.20548178600006, 36.025797509000029],
          [120.20546836300002, 36.02580355200007],
          [120.20544209900004, 36.025818326000035],
          [120.20543203000011, 36.025825908000058],
          [120.20540725000001, 36.025848341000028],
          [120.20540090100008, 36.02585702600004],
          [120.20538873500004, 36.025873662000038],
          [120.20538170300006, 36.025887493000027],
          [120.20537349100005, 36.02590968700008],
          [120.20537087700006, 36.025920687000053],
          [120.20536738900012, 36.025940596000055],
          [120.20536639800002, 36.025952891000031],
          [120.20536647600011, 36.025964595000062],
          [120.20536924600003, 36.025980829000048],
          [120.20537460200001, 36.025996855000074],
          [120.20538242000009, 36.026015480000069],
          [120.20567159700011, 36.026165153000079],
          [120.20581884100011, 36.026240087000076]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 799,
      "bh": "0302",
      "mc": "20万6号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.019509797671335368,
      "shape_Area": 4.3229694487339651e-6
    },
    "geometry": {
      "rings": [
        [
          [120.20668208600011, 36.026682993000065],
          [120.20672823900009, 36.026675343000079],
          [120.20689609600004, 36.026647514000047],
          [120.20710979600005, 36.026621827000042],
          [120.20713208000006, 36.026619464000078],
          [120.20750129100009, 36.026580180000053],
          [120.20750039300003, 36.026579756000046],
          [120.20749950100003, 36.026579076000075],
          [120.20749856600003, 36.026577876000033],
          [120.20749816200009, 36.026576807000026],
          [120.20749807000004, 36.026575822000041],
          [120.20749819800005, 36.026574913000047],
          [120.20749851900007, 36.026574115000074],
          [120.20749927300005, 36.026573054000039],
          [120.20750026900009, 36.026572226000042],
          [120.20750162500008, 36.02657156500004],
          [120.20750316800002, 36.026571218000072],
          [120.20750489300008, 36.026571238000031],
          [120.20750613300004, 36.026571518000026],
          [120.20750734600006, 36.026572055000031],
          [120.20750817800001, 36.026572636000026],
          [120.20750889700003, 36.026573375000055],
          [120.20750939900006, 36.026574165000056],
          [120.20750972100006, 36.02657504900003],
          [120.20750982600009, 36.026575900000068],
          [120.20750973100007, 36.026576808000073],
          [120.20750937900004, 36.026577777000057],
          [120.20750876800003, 36.026578685000061],
          [120.20750799300004, 36.026579416000061],
          [120.20750721000002, 36.026579924000032],
          [120.20750611400001, 36.026580391000039],
          [120.20750521100001, 36.026580616000047],
          [120.2076862990001, 36.026560919000076],
          [120.20774314800008, 36.026554735000047],
          [120.20780844700005, 36.026547633000064],
          [120.20816778200003, 36.026508548000038],
          [120.20967857300002, 36.026347870000052],
          [120.21128949000001, 36.026160409000056],
          [120.21304456500002, 36.02596853700004],
          [120.21458431300005, 36.025788677000037],
          [120.21497010100006, 36.025746324000067],
          [120.21497351000005, 36.025742919000038],
          [120.21532999100009, 36.025382777000061],
          [120.21517112400011, 36.025277956000025],
          [120.21511831900011, 36.025243269000043],
          [120.21510904200011, 36.025237580000066],
          [120.21510175700007, 36.025234251000029],
          [120.21507607800004, 36.025237186000027],
          [120.21507675800001, 36.025239242000055],
          [120.21507807000012, 36.025253202000044],
          [120.20818874300005, 36.026025643000025],
          [120.20816446100002, 36.026028284000063],
          [120.20644148600002, 36.026215725000043],
          [120.20635222400006, 36.026226185000041],
          [120.20633924400011, 36.026228194000055],
          [120.20633425800008, 36.026228143000026],
          [120.2063288060001, 36.026222222000058],
          [120.20632775900003, 36.026218112000038],
          [120.20631260400012, 36.026219719000039],
          [120.20627771400007, 36.026223650000077],
          [120.20627580200005, 36.026211844000045],
          [120.2062712390001, 36.026183654000079],
          [120.20599596800002, 36.026215793000063],
          [120.2059975730001, 36.026224589000037],
          [120.20590491900009, 36.026235744000076],
          [120.20582968500003, 36.026239200000077],
          [120.20592839500011, 36.026288554000075],
          [120.20594518300004, 36.026298868000026],
          [120.20602167000004, 36.026338129000067],
          [120.20668208600011, 36.026682993000065]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 800,
      "bh": "0302",
      "mc": "10万4号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0076097526020887356,
      "shape_Area": 9.1607161079722766e-7
    },
    "geometry": {
      "rings": [
        [
          [120.22429113500004, 36.029851320000034],
          [120.22433435200003, 36.02980834300007],
          [120.22434191800005, 36.029800820000048],
          [120.22436047000008, 36.029782837000027],
          [120.22160471900008, 36.02797122000004],
          [120.22160225100004, 36.02796666200004],
          [120.22160482100003, 36.027964544000042],
          [120.22160772500001, 36.02796277200008],
          [120.22160980800004, 36.02796141500005],
          [120.22160004000011, 36.027957767000032],
          [120.22159905800004, 36.027957364000031],
          [120.22159006000004, 36.027953660000037],
          [120.22153533400001, 36.027923496000028],
          [120.22150742400004, 36.027908316000037],
          [120.22143255600008, 36.027858965000064],
          [120.22131280700012, 36.02797397300003],
          [120.22124830600001, 36.028042941000024],
          [120.22128327900009, 36.028060603000029],
          [120.22136225700001, 36.02811304100004],
          [120.22135989800006, 36.02811556100005],
          [120.22135853600003, 36.028117049000059],
          [120.2218156890001, 36.028418712000075],
          [120.22259399500001, 36.028931907000072],
          [120.22320455200008, 36.029335901000024],
          [120.22368897900003, 36.029654803000028],
          [120.22367907500006, 36.02966501700007],
          [120.22367791200008, 36.029666180000049],
          [120.22367627500012, 36.029668073000039],
          [120.22369484900003, 36.029680325000072],
          [120.22370190000004, 36.029673291000051],
          [120.22409316500011, 36.029932044000077],
          [120.22410161900007, 36.029923907000068],
          [120.22415053900011, 36.029957444000047],
          [120.22417301300004, 36.029972754000028],
          [120.22430175200009, 36.029858364000063],
          [120.22429113500004, 36.029851320000034]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 801,
      "bh": "0302",
      "mc": "10万3号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0092457113679359978,
      "shape_Area": 2.0011572753018772e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22207064600002, 36.02754991900008],
          [120.22204160600006, 36.027530324000054],
          [120.22203323100007, 36.027529091000076],
          [120.22203189600009, 36.027528894000056],
          [120.22202514100002, 36.027527882000072],
          [120.2220209190001, 36.027525237000077],
          [120.22198878300003, 36.027504530000044],
          [120.2218972930001, 36.027445764000049],
          [120.22169070600012, 36.027652437000029],
          [120.22158647200001, 36.027764730000058],
          [120.22156091800002, 36.027792022000028],
          [120.22156075800001, 36.027792935000036],
          [120.22166220400004, 36.027861739000059],
          [120.22166393600003, 36.027862913000035],
          [120.22166800700006, 36.027866630000062],
          [120.22167369500005, 36.027873407000072],
          [120.22167757900002, 36.027879836000068],
          [120.22168439600011, 36.027880235000055],
          [120.22168868100005, 36.027881117000049],
          [120.22229932700009, 36.02828140500003],
          [120.22269396200011, 36.028540147000058],
          [120.22349794800004, 36.029073461000053],
          [120.22410543800004, 36.029476142000078],
          [120.22468104100005, 36.029858562000072],
          [120.22487433700007, 36.029986983000072],
          [120.2249053920001, 36.030007242000067],
          [120.22490137700004, 36.030011146000049],
          [120.2249432320001, 36.030037020000066],
          [120.22494977000008, 36.030031244000043],
          [120.22499153300009, 36.030059084000072],
          [120.22504656000001, 36.030004625000061],
          [120.22522982400005, 36.02982183000006],
          [120.22532853000007, 36.029721911000024],
          [120.2253478240001, 36.029703189000031],
          [120.22534066900005, 36.029698323000048],
          [120.22533562700005, 36.029703677000043],
          [120.22532485600004, 36.029697554000052],
          [120.22450388800007, 36.029155174000039],
          [120.22207064600002, 36.02754991900008]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 802,
      "bh": "0302",
      "mc": "10万2号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0093902637280059275,
      "shape_Area": 2.0386372823577933e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22248057800005, 36.027093799000056],
          [120.2224778320001, 36.027095045000067],
          [120.22246953000001, 36.027096749000066],
          [120.22246556300001, 36.027097114000071],
          [120.22246314000006, 36.027096500000027],
          [120.22246026200003, 36.02709476800004],
          [120.22228571100004, 36.026980674000072],
          [120.22228471700009, 36.026981682000041],
          [120.22228411100002, 36.026983189000077],
          [120.22228429100005, 36.026985056000058],
          [120.22228538700006, 36.02698668000005],
          [120.22215837200008, 36.027126587000055],
          [120.22215715300001, 36.027125882000064],
          [120.2221548980001, 36.027125385000033],
          [120.22215286800008, 36.027125617000024],
          [120.22215105800001, 36.027126465000038],
          [120.22214984000004, 36.027127700000051],
          [120.22214923400009, 36.027129208000076],
          [120.22214941300001, 36.027131074000067],
          [120.22215040500009, 36.02713254300005],
          [120.22204524300003, 36.027237851000052],
          [120.22195368500002, 36.02732788600008],
          [120.2220281970001, 36.02737858100005],
          [120.22209511500012, 36.027423423000073],
          [120.22210214800009, 36.02742889700005],
          [120.22210759200004, 36.027434794000044],
          [120.22210883800005, 36.027437428000042],
          [120.22210965600004, 36.027441314000043],
          [120.22210969500009, 36.02744541800007],
          [120.22211552300007, 36.027446483000062],
          [120.2221381710001, 36.027460571000063],
          [120.22307879100003, 36.02808062500003],
          [120.22513767500004, 36.029443620000052],
          [120.22532381200006, 36.02956683900004],
          [120.22543112500011, 36.029636227000026],
          [120.22550129400008, 36.029564373000028],
          [120.22565329300005, 36.029410764000033],
          [120.22577547700007, 36.029286640000066],
          [120.22577892400011, 36.029283061000058],
          [120.22577441300007, 36.02928019400008],
          [120.22555397700012, 36.029128849000074],
          [120.2227332650001, 36.027269369000066],
          [120.22249030400008, 36.02710617300005],
          [120.22247959600008, 36.027101300000027],
          [120.22248057800005, 36.027093799000056]
        ],
        [
          [120.22519499800001, 36.029386485000032],
          [120.22519574900002, 36.029385241000057],
          [120.22519676400009, 36.029384292000032],
          [120.22519860000011, 36.029383359000065],
          [120.22520027300004, 36.029383017000043],
          [120.22520228100007, 36.029383099000029],
          [120.22520393200011, 36.029383593000034],
          [120.22520514000007, 36.029384279000055],
          [120.22520620600005, 36.029385283000067],
          [120.22520707700005, 36.029386930000044],
          [120.2252072340001, 36.02938830800008],
          [120.22520667000003, 36.029390210000031],
          [120.22520525100003, 36.02939181000005],
          [120.22520293000002, 36.029392930000029],
          [120.22520043000009, 36.02939316800007],
          [120.2251981710001, 36.029392656000027],
          [120.22519651100004, 36.029391684000075],
          [120.22519568600001, 36.029390853000052],
          [120.2251949350001, 36.029389520000052],
          [120.22519468900009, 36.029387839000037],
          [120.22519499800001, 36.029386485000032]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 803,
      "bh": "0302",
      "mc": "煤1号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.020666406858272524,
      "shape_Area": 3.9970270053767802e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22004817900006, 36.033111516000076],
          [120.21938218500009, 36.032767726000031],
          [120.21190454400005, 36.028907257000071],
          [120.21191354700011, 36.028893999000047],
          [120.21180501900005, 36.028842233000034],
          [120.21181977600008, 36.028823831000068],
          [120.2118293960001, 36.02881155700004],
          [120.2117557250001, 36.028773460000025],
          [120.21164758400005, 36.028911996000033],
          [120.21169467900006, 36.02893688000006],
          [120.21164493400011, 36.028998999000066],
          [120.21161509300009, 36.02898323200003],
          [120.21160889400005, 36.028990972000031],
          [120.21159155100008, 36.029012176000037],
          [120.21158469800002, 36.029020555000045],
          [120.21153066400007, 36.029086622000079],
          [120.21148092300007, 36.029151785000067],
          [120.21147706500005, 36.029157781000038],
          [120.21148247400004, 36.029160653000076],
          [120.21159627400004, 36.029218621000041],
          [120.21160565100001, 36.029208625000024],
          [120.21164508400011, 36.029228872000033],
          [120.21910826700002, 36.033087292000062],
          [120.21978801500006, 36.03343867600006],
          [120.21978466200005, 36.033448496000062],
          [120.21982874800005, 36.033471876000078],
          [120.21981481000012, 36.033490130000075],
          [120.21991091200005, 36.033539814000051],
          [120.22007211000005, 36.033623152000075],
          [120.22012324000002, 36.033649350000076],
          [120.22012866300008, 36.033651880000036],
          [120.22028788500006, 36.033444092000025],
          [120.22029813000006, 36.033430929000076],
          [120.22030407300008, 36.033433384000034],
          [120.22037586800002, 36.033339792000049],
          [120.22037014900002, 36.033337200000062],
          [120.22037413100009, 36.033331405000069],
          [120.22037670300006, 36.033331083000064],
          [120.22037839800009, 36.033330331000059],
          [120.22037998300004, 36.033328930000039],
          [120.22038088000011, 36.033327084000064],
          [120.22038087900012, 36.03332511800005],
          [120.2204046490001, 36.03329397400006],
          [120.22039020500006, 36.033286362000069],
          [120.22031218800009, 36.033245804000046],
          [120.22031557800005, 36.033241535000059],
          [120.22016932700001, 36.033163655000067],
          [120.22009950200004, 36.033123207000074],
          [120.22005672700004, 36.033101416000079],
          [120.22004817900006, 36.033111516000076]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 804,
      "bh": "0302",
      "mc": "前方南堆场1",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0066785043608862645,
      "shape_Area": 1.3864964294607972e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22016162900002, 36.026037120000069],
          [120.22003690400004, 36.026167129000044],
          [120.22005298800002, 36.026176261000046],
          [120.21988121000004, 36.026349518000075],
          [120.21986329100002, 36.026367321000066],
          [120.21985799800007, 36.026375073000054],
          [120.21985574100006, 36.026380593000056],
          [120.21985426700007, 36.026405282000042],
          [120.21985600300002, 36.026428956000075],
          [120.22083907000001, 36.027076534000059],
          [120.22082701700003, 36.027088048000053],
          [120.22095969100008, 36.027175922000026],
          [120.22096558500004, 36.027170051000041],
          [120.22113442900002, 36.026999537000052],
          [120.22129816600011, 36.026835279000068],
          [120.22140015500008, 36.026905634000059],
          [120.22139839100009, 36.026907666000056],
          [120.22149582100008, 36.026969587000053],
          [120.2214942380001, 36.026971231000061],
          [120.22158619800007, 36.027032206000058],
          [120.22174182100002, 36.027135393000037],
          [120.22191027600002, 36.026969686000029],
          [120.2219168470001, 36.026963222000063],
          [120.22191776700004, 36.026962456000035],
          [120.22191662500006, 36.02696200400004],
          [120.22191403000011, 36.026960564000035],
          [120.22191148600007, 36.026958572000069],
          [120.22190914600003, 36.026955871000041],
          [120.2219078490001, 36.026953598000034],
          [120.22190695600011, 36.026951021000059],
          [120.22190660000001, 36.026948459000039],
          [120.22190660500007, 36.02694729500007],
          [120.22190689900003, 36.026945079000029],
          [120.22190757300007, 36.026942899000062],
          [120.22190867600011, 36.02694070900003],
          [120.22190937300002, 36.026939666000033],
          [120.22191051700008, 36.026938266000059],
          [120.22191202400006, 36.02693680200008],
          [120.22191339500012, 36.02693572700008],
          [120.22191588100009, 36.026934216000029],
          [120.22191820800003, 36.026933188000044],
          [120.22191984900007, 36.026932645000045],
          [120.22192223600007, 36.026931525000066],
          [120.2219230070001, 36.026930997000079],
          [120.22192334600004, 36.026930506000042],
          [120.22192374500003, 36.026929017000043],
          [120.22192368500009, 36.026926520000075],
          [120.22192403500003, 36.026924072000043],
          [120.22192473200005, 36.026921819000052],
          [120.22192575200006, 36.026919690000057],
          [120.22192717100006, 36.026917578000052],
          [120.22192858800008, 36.026915963000079],
          [120.22193108700003, 36.026913799000056],
          [120.2219336710001, 36.026912158000073],
          [120.22193683400008, 36.026910718000067],
          [120.22193895900011, 36.026910029000078],
          [120.22194545600007, 36.026903968000056],
          [120.22193933800008, 36.026899477000029],
          [120.22199556100009, 36.026842823000038],
          [120.22198221700012, 36.02682311600006],
          [120.22197863300005, 36.026817316000063],
          [120.22197279400007, 36.026810743000055],
          [120.22196568100003, 36.026803701000063],
          [120.22195973900011, 36.026799715000038],
          [120.22174073500003, 36.026657243000045],
          [120.22173046300009, 36.026651246000029],
          [120.22173605300009, 36.026645488000042],
          [120.22173454000006, 36.026646542000037],
          [120.22173073700003, 36.026647345000072],
          [120.22172760400008, 36.026646850000077],
          [120.22172478100003, 36.026645259000077],
          [120.22172287800004, 36.026642431000027],
          [120.22172264200003, 36.02664039800004],
          [120.22172323400002, 36.026638312000046],
          [120.22172436400001, 36.026636748000044],
          [120.22172625900009, 36.026635340000041],
          [120.22172843100009, 36.026634526000066],
          [120.22173220200011, 36.026634386000069],
          [120.22173504000011, 36.026631565000059],
          [120.22173119900003, 36.026629017000062],
          [120.22160668400011, 36.026548338000055],
          [120.22157540000001, 36.026528069000051],
          [120.22133187800011, 36.026367789000062],
          [120.22124401100007, 36.026310527000078],
          [120.22122837300003, 36.026298920000045],
          [120.22120798800006, 36.026285422000058],
          [120.22106245200007, 36.02618904600007],
          [120.22105775800003, 36.026193724000052],
          [120.22105609800008, 36.026197643000046],
          [120.22105357200007, 36.026199402000032],
          [120.22104976900005, 36.026200205000066],
          [120.2210466360001, 36.026199710000071],
          [120.22104381300005, 36.026198119000071],
          [120.22103709100008, 36.026193113000033],
          [120.22102456400012, 36.026184644000068],
          [120.22055442600004, 36.025874574000056],
          [120.22054258900005, 36.025868109000044],
          [120.22054307800011, 36.02586761200007],
          [120.22053744600009, 36.025863959000048],
          [120.22053462400004, 36.025862368000048],
          [120.22053272200003, 36.025859540000056],
          [120.22053248500004, 36.025857507000069],
          [120.22053307800002, 36.025855422000063],
          [120.22053420700001, 36.025853857000072],
          [120.22053610300009, 36.02585244900007],
          [120.22053827400009, 36.025851636000027],
          [120.22054204500012, 36.02585149500004],
          [120.22044097000003, 36.025789816000042],
          [120.22017883500007, 36.026048857000035],
          [120.22016162900002, 36.026037120000069]
        ],
        [
          [120.22121053600006, 36.026305643000057],
          [120.22122001000002, 36.026296445000071],
          [120.22123203100011, 36.026304384000071],
          [120.22158156400008, 36.026535220000028],
          [120.22159317800003, 36.026542891000076],
          [120.22158279600001, 36.026553510000042],
          [120.22157107300006, 36.026545701000032],
          [120.22122082600004, 36.026315580000073],
          [120.2212079630001, 36.026308139000037],
          [120.22121053600006, 36.026305643000057]
        ],
        [
          [120.22160236800005, 36.026552734000063],
          [120.2216007080001, 36.026556654000046],
          [120.22159818300008, 36.026558412000043],
          [120.22159437900007, 36.026559215000077],
          [120.22159124500001, 36.026558721000072],
          [120.22158842300007, 36.026557129000025],
          [120.22158652100006, 36.026554302000079],
          [120.22158628400007, 36.026552268000046],
          [120.22158687700005, 36.02655018300004],
          [120.22158800600005, 36.026548619000039],
          [120.22158990200012, 36.026547210000047],
          [120.22159207300001, 36.026546397000061],
          [120.22159584400003, 36.026546257000064],
          [120.22159962800004, 36.026547762000064],
          [120.22160127400002, 36.026549386000056],
          [120.22160236800005, 36.026552734000063]
        ],
        [
          [120.22120214000006, 36.026291250000043],
          [120.22120431100006, 36.026290438000046],
          [120.22120808300008, 36.02629029600007],
          [120.22121186600009, 36.02629180200006],
          [120.22121351400006, 36.026293427000041],
          [120.2212146060001, 36.026296775000048],
          [120.22121294600004, 36.026300694000042],
          [120.22121042100002, 36.026302452000039],
          [120.22120661800011, 36.026303255000073],
          [120.22120348500005, 36.026302761000068],
          [120.22120066100001, 36.026301169000078],
          [120.22119876000011, 36.026298342000075],
          [120.22119852300011, 36.026296308000042],
          [120.2211991150001, 36.026294223000036],
          [120.22120024500009, 36.026292659000035],
          [120.22120214000006, 36.026291250000043]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 805,
      "bh": "0302",
      "mc": "前方南堆场2",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0042884192894212603,
      "shape_Area": 1.0509521850602175e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21995518000006, 36.026095459000032],
          [120.22006773400005, 36.025982456000065],
          [120.22005161200002, 36.025973500000077],
          [120.22006145500006, 36.025963551000075],
          [120.22028995200003, 36.025732582000046],
          [120.22025618200007, 36.025710090000075],
          [120.22027960500009, 36.025685594000038],
          [120.22004009900002, 36.025526582000055],
          [120.2200282550001, 36.025520394000068],
          [120.22003936700003, 36.025508825000031],
          [120.21987346200001, 36.025398454000026],
          [120.21986244600009, 36.025409596000031],
          [120.21985047900012, 36.025401346000024],
          [120.21966816400004, 36.025280366000061],
          [120.21965652900008, 36.025274421000063],
          [120.21966763300009, 36.025262858000076],
          [120.21950483500007, 36.025153851000027],
          [120.21949435900001, 36.025164438000047],
          [120.21948230400005, 36.025157197000055],
          [120.21930665100001, 36.025041312000042],
          [120.2190977140001, 36.02524528500004],
          [120.21908574400004, 36.025237567000033],
          [120.21892278600001, 36.025396363000027],
          [120.21891926500007, 36.025399733000029],
          [120.21892980200005, 36.025406998000051],
          [120.21867498000006, 36.025651143000061],
          [120.21966082500001, 36.026300310000067],
          [120.21966515300005, 36.026301958000033],
          [120.21966999300002, 36.026302496000028],
          [120.21968182900002, 36.026302797000028],
          [120.21969380500002, 36.026301241000056],
          [120.21970353600011, 36.02629941500004],
          [120.21971614100005, 36.026296738000042],
          [120.21972644700008, 36.026293022000061],
          [120.21974081700012, 36.026285822000034],
          [120.21974598100007, 36.026281088000076],
          [120.21976582500008, 36.02626091500008],
          [120.21993871100005, 36.026086536000037],
          [120.21995518000006, 36.026095459000032]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 806,
      "bh": "0302",
      "mc": "前方北堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.011639574861592979,
      "shape_Area": 2.4239020528696992e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21707616000003, 36.024748410000029],
          [120.2170728100001, 36.024746330000028],
          [120.21698658700006, 36.024691773000029],
          [120.21696823700006, 36.024680406000073],
          [120.21695175100001, 36.02467421700004],
          [120.21693413300011, 36.024670150000077],
          [120.21691379000004, 36.024666870000033],
          [120.21690079500002, 36.024665895000055],
          [120.21689058700008, 36.024667349000026],
          [120.21687762400006, 36.024670583000045],
          [120.21685806900007, 36.024675217000038],
          [120.21682938600009, 36.024714422000045],
          [120.21655739000005, 36.024974943000075],
          [120.21659146800005, 36.024997605000067],
          [120.21660344200006, 36.025005570000076],
          [120.21660430400004, 36.025006142000052],
          [120.21763647500006, 36.025686664000034],
          [120.21765334700001, 36.025670378000029],
          [120.21771722200003, 36.025712714000065],
          [120.21770329500009, 36.025726182000028],
          [120.22077472100011, 36.02775424500004],
          [120.22083237600009, 36.027701508000064],
          [120.22084925400009, 36.027713092000056],
          [120.22114386200008, 36.027430860000038],
          [120.22083601400004, 36.027228441000034],
          [120.22083105600007, 36.027225179000027],
          [120.22084357800009, 36.027212141000064],
          [120.22083672800011, 36.027207583000063],
          [120.22083536800005, 36.027209676000041],
          [120.22083324000005, 36.027211291000071],
          [120.22082968100005, 36.027212398000074],
          [120.22082674700005, 36.027212347000045],
          [120.22082407800008, 36.02721155100005],
          [120.22082117900004, 36.027209398000025],
          [120.22081977200003, 36.02720664800006],
          [120.22081992700009, 36.027203493000059],
          [120.2208214850001, 36.027200960000073],
          [120.22061101200006, 36.027054543000077],
          [120.22061069000006, 36.027057127000035],
          [120.22060911000005, 36.027059173000055],
          [120.2206075790001, 36.027060113000061],
          [120.22060561000001, 36.027060698000071],
          [120.22060202700004, 36.027060483000071],
          [120.22059983000008, 36.027059437000048],
          [120.22059838300004, 36.027057986000045],
          [120.22059796600001, 36.027057264000064],
          [120.22059755200007, 36.027055852000046],
          [120.22059763300001, 36.027054282000051],
          [120.22059819100002, 36.027052902000037],
          [120.22059925300005, 36.027051616000051],
          [120.22060056100008, 36.027050700000075],
          [120.22059821100004, 36.027048825000065],
          [120.22058679800011, 36.027059808000047],
          [120.22019048400011, 36.026796253000043],
          [120.22009907200004, 36.026735673000076],
          [120.22006983300003, 36.026764786000058],
          [120.22003549400006, 36.026742029000047],
          [120.22006406700007, 36.026713579000045],
          [120.21976265900003, 36.026513832000035],
          [120.21976990900009, 36.02650428000004],
          [120.21976653000002, 36.026502058000062],
          [120.21976514900007, 36.026503387000048],
          [120.21976211100002, 36.026504575000047],
          [120.21975966400009, 36.026504722000027],
          [120.21975781900005, 36.026504412000065],
          [120.21975583500011, 36.02650359900008],
          [120.21975449200011, 36.026502633000064],
          [120.21975315900011, 36.026500958000042],
          [120.21975249400009, 36.026498221000054],
          [120.21975305300009, 36.02649602300005],
          [120.21975464700006, 36.026494208000031],
          [120.21975459700002, 36.026494174000049],
          [120.2196031310001, 36.026391335000028],
          [120.2195995190001, 36.026389040000026],
          [120.21959371300011, 36.026385342000026],
          [120.2195928540001, 36.026387419000059],
          [120.21959081000011, 36.026389387000052],
          [120.21958777300006, 36.02639057500005],
          [120.21958532400004, 36.026390723000077],
          [120.2195834800001, 36.026390413000058],
          [120.21958149500006, 36.026389599000026],
          [120.21958015300004, 36.026388633000067],
          [120.21957882000004, 36.026386958000046],
          [120.21957815500002, 36.026384221000058],
          [120.21957871500001, 36.026382023000053],
          [120.21958086100005, 36.026379579000036],
          [120.21958292400006, 36.026378536000038],
          [120.21958350600005, 36.026378462000025],
          [120.21958187500002, 36.026377385000046],
          [120.21956994200002, 36.026388075000057],
          [120.21905014600009, 36.026044163000051],
          [120.2190596160001, 36.026033834000032],
          [120.21886056200003, 36.025901015000045],
          [120.2188506980001, 36.025911865000069],
          [120.21807923200004, 36.025404596000044],
          [120.21808999700011, 36.025393805000078],
          [120.2180894280001, 36.025393430000065],
          [120.21796572500011, 36.025311090000059],
          [120.21796594000011, 36.025313293000067],
          [120.21796485900006, 36.025315884000065],
          [120.21796313400012, 36.025317468000026],
          [120.21795937400009, 36.025318758000026],
          [120.21795783500011, 36.025318789000039],
          [120.21795439900006, 36.025317865000034],
          [120.21795284500001, 36.025316812000028],
          [120.21795156000007, 36.025315241000044],
          [120.21795087600003, 36.025313010000048],
          [120.21795123100003, 36.025310782000076],
          [120.21795214700001, 36.025309247000052],
          [120.21795396200002, 36.025307714000064],
          [120.2179566640001, 36.025306698000065],
          [120.21795824200001, 36.025306670000077],
          [120.2179573200001, 36.025305916000036],
          [120.21795442500002, 36.025304008000035],
          [120.2179438710001, 36.025314581000032],
          [120.21766955500004, 36.025133353000058],
          [120.21767977800005, 36.025123112000074],
          [120.21767632000001, 36.025120835000052],
          [120.2175122220001, 36.025012749000041],
          [120.21750844000007, 36.025010221000059],
          [120.21749640400003, 36.02502210800003],
          [120.21745814300004, 36.024997467000048],
          [120.21745318900003, 36.025002892000032],
          [120.21741525700008, 36.024975958000027],
          [120.21741442600012, 36.024975487000063],
          [120.21708654400004, 36.02476309900004],
          [120.21708210700001, 36.02476022500008],
          [120.21707875900006, 36.024763703000076],
          [120.21706824900002, 36.024756750000051],
          [120.21707616000003, 36.024748410000029]
        ],
        [
          [120.21766241600005, 36.025127631000032],
          [120.21766086300011, 36.025126577000037],
          [120.21765957800005, 36.025125006000053],
          [120.21765889400001, 36.025122776000046],
          [120.21765924800002, 36.025120547000029],
          [120.2176601650001, 36.025119013000051],
          [120.21766197900001, 36.025117479000073],
          [120.21766468100009, 36.025116464000064],
          [120.21766787600006, 36.025116408000031],
          [120.21767087700005, 36.02511746600004],
          [120.21767235600009, 36.025118615000054],
          [120.2176737420001, 36.025120856000058],
          [120.21767395800009, 36.025123059000066],
          [120.21767287600005, 36.025125650000064],
          [120.2176711510001, 36.02512723500007],
          [120.21766739100008, 36.025128524000024],
          [120.21766585300009, 36.025128555000038],
          [120.21766241600005, 36.025127631000032]
        ],
        [
          [120.21904225500009, 36.02603832300008],
          [120.21904070300002, 36.026037269000028],
          [120.21903941700009, 36.026035698000044],
          [120.21903873300005, 36.026033469000026],
          [120.21903908700006, 36.026031240000066],
          [120.21904000400002, 36.026029706000031],
          [120.21904181800005, 36.026028171000064],
          [120.21904452000001, 36.026027156000055],
          [120.21904771600009, 36.026027100000078],
          [120.21905071600008, 36.026028158000031],
          [120.21905219400003, 36.026029307000044],
          [120.21905358200002, 36.026031548000049],
          [120.21905379700002, 36.026033751000057],
          [120.21905271500009, 36.026036343000044],
          [120.21905099000003, 36.026037927000061],
          [120.21904723000011, 36.026039217000061],
          [120.21904569200001, 36.026039247000028],
          [120.21904225500009, 36.02603832300008]
        ],
        [
          [120.21750844300004, 36.025026948000061],
          [120.2175068900001, 36.025025895000056],
          [120.21750560500004, 36.025024324000071],
          [120.2175049220001, 36.025022093000075],
          [120.21750527600011, 36.025019864000058],
          [120.21750619300008, 36.02501833000008],
          [120.21750800600012, 36.025016796000045],
          [120.21751070800008, 36.025015781000036],
          [120.21751390400004, 36.02501572400007],
          [120.21751690300005, 36.02501678200008],
          [120.21751838200009, 36.025017931000036],
          [120.21751977000008, 36.02502017300003],
          [120.21751998400009, 36.025022375000049],
          [120.21751890400003, 36.025024967000036],
          [120.21751717800009, 36.025026551000053],
          [120.21751341900006, 36.025027841000053],
          [120.21751187900009, 36.025027871000077],
          [120.21750844300004, 36.025026948000061]
        ],
        [
          [120.21885869700009, 36.025915649000069],
          [120.21885714300004, 36.025914596000064],
          [120.21885585900009, 36.025913025000079],
          [120.21885517500004, 36.025910795000073],
          [120.21885552900005, 36.025908566000055],
          [120.21885644600002, 36.025907032000077],
          [120.21885826000005, 36.025905498000043],
          [120.21886096200001, 36.02590448400008],
          [120.2188641570001, 36.025904426000068],
          [120.21886715800008, 36.025905484000077],
          [120.21886863600002, 36.025906633000034],
          [120.21887002300002, 36.025908875000027],
          [120.21887023800002, 36.025911077000046],
          [120.21886915700009, 36.025913669000033],
          [120.21886743200002, 36.025915253000051],
          [120.21886367200011, 36.025916543000051],
          [120.21886213400001, 36.025916573000075],
          [120.21885869700009, 36.025915649000069]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 807,
      "bh": "0302",
      "mc": "煤4号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.020855095171308777,
      "shape_Area": 4.0440720014107512e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21850200800009, 36.030488579000064],
          [120.21774656100001, 36.030098485000053],
          [120.21290034000003, 36.027595810000037],
          [120.21282589400005, 36.027553702000034],
          [120.21283212300011, 36.027543846000071],
          [120.21277257800011, 36.027513309000028],
          [120.21277986200005, 36.027494052000065],
          [120.21278658200004, 36.02747962400008],
          [120.21275101500009, 36.027498406000063],
          [120.21245833800003, 36.027873356000043],
          [120.21254832200009, 36.027919804000078],
          [120.21255428800009, 36.027912178000065],
          [120.21256583700006, 36.027918050000039],
          [120.21257866600001, 36.027901402000055],
          [120.21265301900007, 36.027939888000049],
          [120.21265901100003, 36.027942212000028],
          [120.21266689800007, 36.02793241300003],
          [120.21527401000003, 36.029278258000033],
          [120.21749214300007, 36.03042664700007],
          [120.22108844500008, 36.03228839500008],
          [120.22108411600004, 36.032294967000041],
          [120.22112858800006, 36.032319578000056],
          [120.2212389550001, 36.032378323000046],
          [120.22124354500011, 36.032380813000032],
          [120.22153895100007, 36.031999805000055],
          [120.2214304040001, 36.031943570000067],
          [120.22140434200003, 36.031973613000048],
          [120.22135673100001, 36.031946364000078],
          [120.2213465640001, 36.031957988000045],
          [120.21850200800009, 36.030488579000064]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 808,
      "bh": "0302",
      "mc": "煤5号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.022253055532666349,
      "shape_Area": 4.2227745747210638e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21801609900001, 36.029837635000035],
          [120.21797175000006, 36.029808023000044],
          [120.21798123200006, 36.029795790000037],
          [120.21780913300006, 36.029681845000027],
          [120.21779890300002, 36.029675071000042],
          [120.21759726100004, 36.029540793000024],
          [120.21758587800002, 36.02955223400005],
          [120.21757444200011, 36.02954453500007],
          [120.21693797800003, 36.029124692000039],
          [120.21692692900001, 36.029117768000049],
          [120.21693809900012, 36.029106547000026],
          [120.21692701500001, 36.029099313000074],
          [120.21675112500009, 36.028984312000034],
          [120.21673941900008, 36.028976409000052],
          [120.21673924900006, 36.028976294000074],
          [120.21672978700008, 36.028986803000066],
          [120.21671994300004, 36.028980834000038],
          [120.2160818750001, 36.028560535000054],
          [120.21607201900008, 36.028554145000044],
          [120.21608238900001, 36.028543772000035],
          [120.21607074600001, 36.028535807000026],
          [120.21607766500006, 36.02852991900005],
          [120.21587960300008, 36.028399189000027],
          [120.21587345300009, 36.028405371000076],
          [120.21586184200009, 36.028397510000048],
          [120.21584989200005, 36.028408290000073],
          [120.21583992900003, 36.028401407000047],
          [120.21585143600009, 36.02839035900007],
          [120.21521312200002, 36.027971051000065],
          [120.21520983200003, 36.02796886200008],
          [120.21520980100001, 36.027970187000051],
          [120.21520899500001, 36.027971983000043],
          [120.21520735900003, 36.027973670000051],
          [120.21520489300008, 36.027974900000061],
          [120.21520275700004, 36.027975301000026],
          [120.2151997950001, 36.027975054000024],
          [120.2151970860001, 36.027973888000076],
          [120.21519533700007, 36.027972266000063],
          [120.21519440100008, 36.027970449000065],
          [120.21519421800008, 36.027968224000062],
          [120.21519505000003, 36.02796597300005],
          [120.21519684600003, 36.027964104000034],
          [120.21520047100012, 36.027962634000062],
          [120.21502812100005, 36.027847955000027],
          [120.21502859500004, 36.027849014000026],
          [120.21502854300002, 36.027851328000054],
          [120.21502773700001, 36.027853125000036],
          [120.21502609900006, 36.027854811000054],
          [120.21502363400009, 36.027856041000064],
          [120.21502149700007, 36.027856442000029],
          [120.21501853500001, 36.027856195000027],
          [120.21501582600001, 36.027855029000079],
          [120.21501407700009, 36.027853407000066],
          [120.21501314300008, 36.027851591000058],
          [120.2150129580001, 36.027849365000066],
          [120.21501379200004, 36.027847114000053],
          [120.21501558600005, 36.027845244000048],
          [120.21501921300012, 36.027843774000075],
          [120.21502196000006, 36.027843856000061],
          [120.21501812000008, 36.027841301000024],
          [120.21500627300009, 36.027852815000074],
          [120.2143507830001, 36.027415591000079],
          [120.21434067400003, 36.027408868000066],
          [120.21435071600001, 36.027398709000067],
          [120.21433744700005, 36.02738892900004],
          [120.21420489700006, 36.027306623000072],
          [120.21416835900004, 36.027284448000046],
          [120.2141579800001, 36.02729604700005],
          [120.21414966400005, 36.027291522000041],
          [120.21370341600004, 36.027038081000057],
          [120.21365182300008, 36.026996932000031],
          [120.21355333400004, 36.027045515000054],
          [120.21353823000004, 36.027052284000035],
          [120.21346089700012, 36.027089877000037],
          [120.21316095300006, 36.027107006000051],
          [120.21266030700008, 36.027136806000044],
          [120.21265094100011, 36.027139404000025],
          [120.21248527500006, 36.027208403000031],
          [120.21247831400001, 36.027211281000064],
          [120.21246963400006, 36.027217553000071],
          [120.21243227000002, 36.02723250400004],
          [120.21255244700001, 36.027293320000069],
          [120.21260083600009, 36.027319073000058],
          [120.21261375900008, 36.027327046000039],
          [120.21270545000004, 36.027373381000075],
          [120.21280500700004, 36.02742414800008],
          [120.21281007800008, 36.027421469000046],
          [120.21283581300008, 36.027453626000067],
          [120.21287367400009, 36.027472678000038],
          [120.21289439300006, 36.027447533000043],
          [120.21290713100007, 36.027440972000079],
          [120.21291236500008, 36.027443679000044],
          [120.21292677100007, 36.027451696000071],
          [120.21298193700011, 36.027478527000028],
          [120.21536060800008, 36.028708675000075],
          [120.21783411100012, 36.029985557000032],
          [120.21786699200004, 36.030002530000047],
          [120.21832257500012, 36.030237704000058],
          [120.22143382100012, 36.031847622000043],
          [120.22142653000003, 36.03185565900003],
          [120.22146934000011, 36.031878091000067],
          [120.22173148100001, 36.032001396000055],
          [120.2217411150001, 36.031988892000072],
          [120.22172932500007, 36.031983099000058],
          [120.22173986200005, 36.031968950000078],
          [120.22192300300003, 36.031751131000078],
          [120.22190929500005, 36.03174352700006],
          [120.2219186320001, 36.031733200000076],
          [120.22190894900007, 36.031727297000032],
          [120.22190526600002, 36.031728713000064],
          [120.22188891000008, 36.031718622000028],
          [120.22189778400002, 36.031707697000058],
          [120.2216277230001, 36.031532880000043],
          [120.22161655500008, 36.031543271000032],
          [120.22159906900004, 36.031531673000075],
          [120.22159554700011, 36.031535059000078],
          [120.22158295400004, 36.031528072000071],
          [120.22079481900005, 36.031011392000039],
          [120.22063647100003, 36.031049795000058],
          [120.22062314200002, 36.031053028000031],
          [120.22055880300002, 36.031063549000066],
          [120.22051511200004, 36.031071117000067],
          [120.22046849000003, 36.031079520000048],
          [120.22043760800011, 36.031082103000074],
          [120.22038941100004, 36.031080890000055],
          [120.22035380700004, 36.031072057000074],
          [120.22033841400003, 36.031065234000039],
          [120.22019134000004, 36.030986996000024],
          [120.21978450400002, 36.030741624000029],
          [120.21979460900002, 36.03073061300006],
          [120.2197837110001, 36.030724014000043],
          [120.21978665800009, 36.030726028000061],
          [120.21978759000001, 36.030728435000071],
          [120.21978732300011, 36.03073050100005],
          [120.21978563100004, 36.030732844000056],
          [120.21978326900012, 36.030734136000035],
          [120.21978038100008, 36.03073455100008],
          [120.2197778310001, 36.030734077000034],
          [120.21977589000005, 36.030733043000055],
          [120.21977443800006, 36.030731493000076],
          [120.21977365900011, 36.030729008000037],
          [120.21977415400011, 36.030726790000074],
          [120.21977555300009, 36.030725004000033],
          [120.21977781400005, 36.030723705000071],
          [120.21978072200011, 36.030723221000073],
          [120.2197837110001, 36.030724014000043],
          [120.21978725100007, 36.030721153000059],
          [120.21963074300004, 36.030626936000033],
          [120.21962508900003, 36.030631688000028],
          [120.21961889300007, 36.030627055000025],
          [120.21960970300006, 36.030621490000044],
          [120.21918448100007, 36.030363967000028],
          [120.21918012000003, 36.030361326000047],
          [120.2191773620001, 36.030359683000029],
          [120.21896903700008, 36.030251048000025],
          [120.21895797500008, 36.030262442000037],
          [120.21895079000001, 36.030258466000078],
          [120.21848765800007, 36.029992791000041],
          [120.21829546700008, 36.029919609000046],
          [120.21828316900007, 36.029914943000051],
          [120.21829071800005, 36.029902470000025],
          [120.21806186600008, 36.02984857000007],
          [120.21804478200011, 36.029837867000026],
          [120.21803298600003, 36.029848841000046],
          [120.21802265700001, 36.029842014000053],
          [120.21801609900001, 36.029837635000035]
        ],
        [
          [120.21585837800001, 36.028411574000074],
          [120.21585706100007, 36.028410707000035],
          [120.21585558100003, 36.028408799000033],
          [120.21585519500002, 36.028407505000075],
          [120.21585523200008, 36.028405975000055],
          [120.21585593600003, 36.028404254000066],
          [120.21585685700006, 36.028403168000068],
          [120.21585807400004, 36.028402286000073],
          [120.21585955400008, 36.028401648000056],
          [120.21586132400012, 36.02840130800007],
          [120.21586313300008, 36.028401358000053],
          [120.21586565100006, 36.028402138000047],
          [120.21586751200005, 36.028403786000069],
          [120.21586865000006, 36.02840550600007],
          [120.21586884600003, 36.02840709700007],
          [120.21586816600006, 36.028409276000048],
          [120.21586679000006, 36.028410828000062],
          [120.21586456200009, 36.028412011000057],
          [120.21586181600003, 36.02841241200008],
          [120.21585978500002, 36.028412116000027],
          [120.21585837800001, 36.028411574000074]
        ],
        [
          [120.21606666900004, 36.028547880000076],
          [120.2160653520001, 36.028547013000036],
          [120.21606387300005, 36.028545105000035],
          [120.21606348500006, 36.028543811000077],
          [120.21606352200001, 36.028542281000057],
          [120.21606422600007, 36.028540560000067],
          [120.2160651480001, 36.02853947400007],
          [120.21606636400008, 36.028538592000075],
          [120.21606784500011, 36.028537954000058],
          [120.21606961500004, 36.028537614000072],
          [120.21607142400001, 36.028537664000055],
          [120.21607394200009, 36.028538444000048],
          [120.21607580400007, 36.028540091000025],
          [120.2160769410001, 36.028541812000071],
          [120.21607713600008, 36.028543403000072],
          [120.21607645800009, 36.02854558100006],
          [120.21607508200009, 36.028547134000064],
          [120.21607285400012, 36.028548317000059],
          [120.21607010800005, 36.028548718000025],
          [120.21606807700005, 36.028548422000028],
          [120.21606666900004, 36.028547880000076]
        ],
        [
          [120.21961423800008, 36.030640350000056],
          [120.21961278700007, 36.030638800000077],
          [120.21961200800001, 36.030636316000027],
          [120.21961250300001, 36.030634097000075],
          [120.21961390300009, 36.030632313000069],
          [120.21961616300007, 36.030631013000061],
          [120.21961907000002, 36.030630530000053],
          [120.21962205900002, 36.03063132300008],
          [120.21962500600011, 36.030633336000051],
          [120.21962593800004, 36.030635743000062],
          [120.21962567200001, 36.03063781000003],
          [120.21962398000005, 36.030640152000046],
          [120.21962161700003, 36.030641444000025],
          [120.2196187290001, 36.03064186000006],
          [120.21961618000012, 36.03064138600007],
          [120.21961423800008, 36.030640350000056]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 809,
      "bh": "0302",
      "mc": "20万4号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.016048873802938846,
      "shape_Area": 2.9433452637419338e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21844696300002, 36.029346735000047],
          [120.21836920600003, 36.029295352000076],
          [120.21701139300001, 36.028398065000033],
          [120.21577654100008, 36.027585843000054],
          [120.21537427900012, 36.027319922000061],
          [120.21497490600007, 36.027055394000058],
          [120.21496917900004, 36.027049205000026],
          [120.21498039400001, 36.027036253000063],
          [120.21499266800004, 36.027026404000026],
          [120.21497847600006, 36.027016846000038],
          [120.21498707800004, 36.027008417000047],
          [120.21500236100007, 36.027018711000039],
          [120.21501054600003, 36.027011350000066],
          [120.21479809500011, 36.026871301000028],
          [120.2147614160001, 36.02690717400003],
          [120.21475752400011, 36.026910607000048],
          [120.21476380100012, 36.026914497000064],
          [120.2146591290001, 36.027015788000028],
          [120.21467247500004, 36.027023361000033],
          [120.21443476000002, 36.027285264000056],
          [120.21470217600006, 36.02746221600006],
          [120.21469215900004, 36.027469433000078],
          [120.21469802100012, 36.027473953000026],
          [120.21470155300005, 36.027479087000074],
          [120.21470099800001, 36.027483156000073],
          [120.21470008200004, 36.027485030000037],
          [120.21494190800001, 36.027644422000037],
          [120.21495737900011, 36.027654619000032],
          [120.2149635180001, 36.027651044000038],
          [120.21497454100006, 36.027640494000025],
          [120.21498220700005, 36.02764545000008],
          [120.21513198300011, 36.027743647000079],
          [120.21516160300007, 36.027762700000039],
          [120.21519629900001, 36.027729854000029],
          [120.21534164800005, 36.027819715000078],
          [120.21534128600001, 36.027845177000074],
          [120.21547797000005, 36.027937859000076],
          [120.21551222400001, 36.027927715000033],
          [120.2155535820001, 36.027955702000042],
          [120.21556311300003, 36.027961593000043],
          [120.21555419400011, 36.027970608000032],
          [120.21555956300006, 36.02797342100007],
          [120.21556170000008, 36.027978187000031],
          [120.21556212700011, 36.027983776000042],
          [120.21555967000006, 36.027990331000069],
          [120.2155555060001, 36.027995296000029],
          [120.21555138200006, 36.027998373000059],
          [120.21554504000005, 36.02800046200008],
          [120.21553736100009, 36.028000127000041],
          [120.21572622300005, 36.028125111000065],
          [120.21571852200009, 36.028116153000042],
          [120.21571661000007, 36.028110456000036],
          [120.21571889200004, 36.028103221000038],
          [120.21572427600006, 36.028097550000041],
          [120.21573394400002, 36.028093375000026],
          [120.21574161500007, 36.028095018000045],
          [120.21574544000009, 36.028096378000043],
          [120.21575337200011, 36.028088452000077],
          [120.21576053000001, 36.028093289000026],
          [120.21581705400001, 36.028131479000024],
          [120.21581086100002, 36.028165018000038],
          [120.21594356200001, 36.028254814000036],
          [120.21597983800007, 36.02824193400005],
          [120.21605168400004, 36.028290432000063],
          [120.2160466680001, 36.028320053000073],
          [120.2161687680001, 36.028401163000069],
          [120.21617476600011, 36.028405147000058],
          [120.21616529400001, 36.028415654000071],
          [120.21624340800008, 36.028473317000078],
          [120.21638480600006, 36.028559169000062],
          [120.21639607100008, 36.028549966000071],
          [120.21654521900007, 36.028650356000071],
          [120.21657968500006, 36.028637397000068],
          [120.2166524380001, 36.028687141000034],
          [120.21665271300003, 36.028722238000057],
          [120.21681474500008, 36.028829556000062],
          [120.21686197600002, 36.028814382000064],
          [120.21691040500002, 36.028848029000073],
          [120.21690201800004, 36.028856200000064],
          [120.21690433300012, 36.028857767000034],
          [120.21690965200003, 36.028861089000031],
          [120.21691323800007, 36.028864892000058],
          [120.2169132570001, 36.028874348000045],
          [120.21691164000003, 36.028880180000044],
          [120.21690145600007, 36.028889216000039],
          [120.21689616100002, 36.028891599000076],
          [120.21688298800007, 36.028890976000071],
          [120.21712218000005, 36.02904737700004],
          [120.21712051700001, 36.029039977000025],
          [120.21712065800011, 36.029035794000038],
          [120.21712664000006, 36.029023813000038],
          [120.21713342900011, 36.029019511000058],
          [120.21714519600005, 36.029023092000045],
          [120.2171571670001, 36.029012781000063],
          [120.21734588300001, 36.029136605000076],
          [120.21733463600003, 36.029172182000025],
          [120.21748444000002, 36.029271222000034],
          [120.21752189000006, 36.029260813000064],
          [120.2177251280001, 36.029394289000038],
          [120.21771186900003, 36.029403840000043],
          [120.21771985300006, 36.029409781000027],
          [120.21771846400009, 36.029415150000034],
          [120.21771403900004, 36.029420921000053],
          [120.21770922600001, 36.029424010000071],
          [120.21769938000011, 36.029426577000038],
          [120.21769286900008, 36.029425006000054],
          [120.21785620800006, 36.029536455000027],
          [120.21787711000002, 36.029514291000055],
          [120.21787585300001, 36.029513271000042],
          [120.21788016500011, 36.029508281000062],
          [120.21788173100003, 36.029506649000041],
          [120.21790188500006, 36.029519011000048],
          [120.21794558700003, 36.029547144000048],
          [120.21795721300009, 36.029537061000042],
          [120.21795920900001, 36.029536033000056],
          [120.21809371400002, 36.029625466000027],
          [120.21808722200001, 36.029659077000076],
          [120.21808669900008, 36.029661784000041],
          [120.21814032200007, 36.029695498000024],
          [120.21818538700006, 36.029723831000069],
          [120.21822237400011, 36.029707231000032],
          [120.21830897600012, 36.029763737000053],
          [120.21830898300004, 36.029788443000029],
          [120.21831359100008, 36.029789736000055],
          [120.21833221500003, 36.029793306000045],
          [120.21841048700003, 36.029807554000058],
          [120.21844859400005, 36.029785461000074],
          [120.21861787600005, 36.029886859000044],
          [120.2186108300001, 36.029893249000054],
          [120.21861847200012, 36.029905515000053],
          [120.21861908400001, 36.029910581000024],
          [120.21861798500004, 36.02991948600004],
          [120.21861340400005, 36.029923704000055],
          [120.21859405300006, 36.029924126000026],
          [120.21887257300011, 36.030087080000044],
          [120.21886784900005, 36.030077121000033],
          [120.21886640200012, 36.030069161000029],
          [120.21887891500012, 36.030060942000034],
          [120.21889410800009, 36.030059334000043],
          [120.21890188800012, 36.030062840000028],
          [120.2189085870001, 36.030055263000065],
          [120.2190779770001, 36.030154502000073],
          [120.21906886700003, 36.030186979000064],
          [120.21918669100012, 36.030257190000043],
          [120.21922434200008, 36.03024253600006],
          [120.21944601900009, 36.030377611000063],
          [120.21943434400009, 36.030388980000055],
          [120.21944154900007, 36.030394099000034],
          [120.21944762500004, 36.03039801400007],
          [120.21944508700005, 36.03040850800005],
          [120.2194386650001, 36.030412712000043],
          [120.21943433400008, 36.030414897000071],
          [120.21942603600007, 36.030415640000058],
          [120.21942114300009, 36.030414374000031],
          [120.21951372100011, 36.030474466000044],
          [120.21962378300009, 36.030537661000039],
          [120.21962019200009, 36.030533585000057],
          [120.21961705800004, 36.030527065000058],
          [120.21961823200002, 36.030521019000048],
          [120.21962389400005, 36.030517023000073],
          [120.2196291140001, 36.030514450000055],
          [120.21963961000006, 36.030513452000037],
          [120.21964530500009, 36.030514999000047],
          [120.21965356200008, 36.030520281000065],
          [120.21966372400004, 36.030509506000044],
          [120.21981946500011, 36.030606100000057],
          [120.2198291840001, 36.030614385000035],
          [120.21983568000007, 36.030623480000031],
          [120.21984016600004, 36.030631944000049],
          [120.21983905800005, 36.030644899000038],
          [120.21982816800005, 36.030644585000061],
          [120.21982035400003, 36.03064855100007],
          [120.21981351000011, 36.030652177000036],
          [120.21980171300004, 36.030648598000028],
          [120.21996485900002, 36.030749722000053],
          [120.21997806700006, 36.030735662000041],
          [120.21998002400005, 36.030730759000051],
          [120.21998477700004, 36.030727328000069],
          [120.21999102700011, 36.030726194000067],
          [120.21999935300005, 36.030729905000044],
          [120.22005744100011, 36.030767113000024],
          [120.22004759900005, 36.030778071000043],
          [120.22007797800006, 36.030796599000041],
          [120.2202424730001, 36.030896919000043],
          [120.22029029700002, 36.030905567000048],
          [120.2203061030001, 36.030905694000069],
          [120.22039044200005, 36.030903134000027],
          [120.22039994700003, 36.030903046000049],
          [120.22040586500009, 36.030914492000079],
          [120.22040609100009, 36.030916885000067],
          [120.22041345700006, 36.030916424000054],
          [120.22057745900008, 36.030777513000032],
          [120.22058966400004, 36.030764852000061],
          [120.22059100500007, 36.030763513000068],
          [120.21844696300002, 36.029346735000047]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 810,
      "bh": "0302",
      "mc": "20万3号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.018711283724647591,
      "shape_Area": 3.558085869257175e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21507865400008, 36.026946298000041],
          [120.21632380500012, 36.027764435000051],
          [120.2184652740001, 36.029171434000034],
          [120.22185850800008, 36.03140069300008],
          [120.22184223000011, 36.031418296000027],
          [120.22188359000006, 36.031443426000067],
          [120.22187338800006, 36.031454893000046],
          [120.22188251200009, 36.031460249000077],
          [120.22210074600002, 36.031607111000028],
          [120.22209034000002, 36.031617360000041],
          [120.22209596100004, 36.031621187000042],
          [120.22209753300001, 36.031619663000072],
          [120.22213357700002, 36.031643333000034],
          [120.22218643700012, 36.031590228000027],
          [120.2222503700001, 36.031528598000079],
          [120.22248704500009, 36.031291723000038],
          [120.22245130900001, 36.031263786000068],
          [120.22244600400006, 36.031268761000035],
          [120.22244283400005, 36.03127008000007],
          [120.22243789700008, 36.031270107000068],
          [120.22243091400003, 36.031267816000025],
          [120.22216843700005, 36.031100268000046],
          [120.22216125200009, 36.031105294000042],
          [120.22215354600007, 36.031108442000061],
          [120.22214171700011, 36.031108464000056],
          [120.22212352500003, 36.031102690000068],
          [120.22177897600011, 36.03087587300007],
          [120.22015690300009, 36.029809903000057],
          [120.21871099500004, 36.028854479000074],
          [120.21693970800004, 36.027683995000075],
          [120.21661544700009, 36.027468322000061],
          [120.21540907100007, 36.026665915000024],
          [120.21539639400009, 36.026657750000027],
          [120.21538752100003, 36.02664857700006],
          [120.2153869230001, 36.026643332000049],
          [120.21538806600006, 36.026639301000046],
          [120.21539247100009, 36.026634540000032],
          [120.21540047600001, 36.026639527000043],
          [120.21536260900007, 36.026615333000052],
          [120.21537022000007, 36.026602900000057],
          [120.21538471100007, 36.026586885000029],
          [120.21520398100006, 36.026467506000074],
          [120.21517126500009, 36.026500039000041],
          [120.21517365500006, 36.026501550000035],
          [120.21506778100002, 36.026607947000059],
          [120.21498530200006, 36.026690414000029],
          [120.21486073700009, 36.026815336000027],
          [120.21485751800003, 36.02681318100008],
          [120.21482804800007, 36.026842004000059],
          [120.21504245300002, 36.026983342000051],
          [120.21507865400008, 36.026946298000041]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 811,
      "bh": "0302",
      "mc": "20万2号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.01861607705238838,
      "shape_Area": 3.5381005781181516e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21803896900008, 36.028213668000035],
          [120.21881180700007, 36.028724441000065],
          [120.21920664300001, 36.028985386000045],
          [120.22190854400003, 36.030766395000057],
          [120.22222376700006, 36.030983978000052],
          [120.22223100200006, 36.030988312000034],
          [120.22223697400011, 36.030992099000059],
          [120.22224148100008, 36.030996486000049],
          [120.22224085800008, 36.03100334100003],
          [120.22223744000007, 36.03101111400008],
          [120.22223303300007, 36.031016798000053],
          [120.22223091800004, 36.031020091000073],
          [120.22236351900006, 36.031105861000071],
          [120.22248600100011, 36.031185591000053],
          [120.22249657800012, 36.031192235000049],
          [120.2224996760001, 36.031194493000044],
          [120.22250246600004, 36.031198291000067],
          [120.22249523800008, 36.031208701000025],
          [120.22250391300008, 36.031213941000033],
          [120.22254176600006, 36.03123593600003],
          [120.22278517900008, 36.030992541000046],
          [120.22288971700004, 36.030879037000034],
          [120.22283957600007, 36.03084571200003],
          [120.2228421320001, 36.030868793000025],
          [120.22274978200005, 36.030808775000025],
          [120.22256901100002, 36.030689410000036],
          [120.22254493000003, 36.030710587000044],
          [120.22197656300011, 36.030335831000059],
          [120.21930283400002, 36.028570381000065],
          [120.21905717300001, 36.028407938000043],
          [120.21787129000006, 36.027623757000072],
          [120.21576650100008, 36.026231870000061],
          [120.21577241600005, 36.026226191000035],
          [120.21557906600003, 36.026096579000068],
          [120.21549881400006, 36.026179777000038],
          [120.21545545600009, 36.026218253000025],
          [120.21537512200007, 36.02630074700005],
          [120.21526849200006, 36.026407805000076],
          [120.21526586100003, 36.026405970000042],
          [120.2152349160001, 36.026436743000033],
          [120.21544769000002, 36.026577289000045],
          [120.21547893600007, 36.026542071000051],
          [120.2154845120001, 36.026538774000073],
          [120.21548854200012, 36.026537845000064],
          [120.21551057200008, 36.026552627000058],
          [120.21566420600004, 36.026650560000064],
          [120.21593735300007, 36.026824366000028],
          [120.21679572400001, 36.027398204000065],
          [120.21758319300011, 36.027914721000059],
          [120.21803896900008, 36.028213668000035]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 812,
      "bh": "0302",
      "mc": "20万1号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.01859571870947016,
      "shape_Area": 3.8157868361836224e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21671490400001, 36.026668156000028],
          [120.21915621500011, 36.028280181000071],
          [120.22266049500001, 36.030593894000049],
          [120.22264086600001, 36.030615943000043],
          [120.22288891200003, 36.030776544000048],
          [120.22289075300012, 36.030774668000049],
          [120.22296331600012, 36.030699950000042],
          [120.22303176500009, 36.030630379000058],
          [120.22309288800011, 36.030568300000027],
          [120.22310681800002, 36.030553913000062],
          [120.22311114600006, 36.030549582000049],
          [120.22322064200011, 36.030439981000029],
          [120.21942271700004, 36.027936411000042],
          [120.21846444200003, 36.027304678000064],
          [120.21846161600001, 36.027307510000071],
          [120.21839902500005, 36.02726629600005],
          [120.21840207000002, 36.027263246000075],
          [120.21839886100008, 36.027261128000077],
          [120.21603097000002, 36.025699269000029],
          [120.21581835900008, 36.025728638000032],
          [120.21575637300009, 36.02579087600003],
          [120.21568621100005, 36.025863489000074],
          [120.21567544800007, 36.025855114000024],
          [120.21554918400011, 36.025970906000055],
          [120.21564000000001, 36.026031119000038],
          [120.21585360200004, 36.026172745000054],
          [120.21587510200004, 36.026149357000065],
          [120.21588633500005, 36.026137694000056],
          [120.21591076000004, 36.026132706000055],
          [120.2159179680001, 36.026137566000045],
          [120.21619696300002, 36.026323886000057],
          [120.21671490400001, 36.026668156000028]
        ],
        [
          [120.22270920000005, 36.030249562000051],
          [120.22269734200006, 36.030261155000062],
          [120.22268607600006, 36.030253340000058],
          [120.22269780700003, 36.030241872000033],
          [120.22270920000005, 36.030249562000051]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 813,
      "bh": "0302",
      "mc": "煤2号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.021220399230733634,
      "shape_Area": 4.0380895875863848e-6
    },
    "geometry": {
      "rings": [
        [
          [120.2206725960001, 36.032818646000067],
          [120.21672028300009, 36.030777690000036],
          [120.21220000800008, 36.028443151000033],
          [120.21220721000009, 36.028432775000056],
          [120.21210972300003, 36.028381213000046],
          [120.21212240400007, 36.028364435000071],
          [120.21212719900007, 36.028359097000077],
          [120.21209305800005, 36.028341313000055],
          [120.21178388300007, 36.028737389000071],
          [120.21186345400008, 36.02877853800004],
          [120.21187084400003, 36.028769110000042],
          [120.21188371400001, 36.028751584000076],
          [120.21190952300003, 36.028764752000029],
          [120.21198285000003, 36.028804315000059],
          [120.21198984400007, 36.028794185000038],
          [120.21204985100007, 36.028822957000045],
          [120.21649459100001, 36.031119218000072],
          [120.22013897500005, 36.033001772000034],
          [120.2202485140001, 36.033062076000078],
          [120.2203986400001, 36.033139236000068],
          [120.22047518500005, 36.033179158000053],
          [120.22048914600009, 36.033183268000073],
          [120.22049418100005, 36.033176535000052],
          [120.22047752300011, 36.033125703000053],
          [120.22048366400008, 36.033122933000072],
          [120.22048265800004, 36.033114707000038],
          [120.22054542300009, 36.033036982000056],
          [120.22054288700008, 36.033036460000062],
          [120.22054141000001, 36.033035634000044],
          [120.22054016300001, 36.033034472000054],
          [120.22053967200009, 36.033033691000071],
          [120.22053917800008, 36.03303175800005],
          [120.22053956600007, 36.033029857000031],
          [120.22054100700007, 36.03302797300006],
          [120.22054321600001, 36.033026747000065],
          [120.22054622200005, 36.033026353000025],
          [120.22054912900001, 36.033027108000056],
          [120.22055070900001, 36.033028197000078],
          [120.22055173300009, 36.033029518000035],
          [120.22055219100002, 36.033030751000069],
          [120.22055217200011, 36.03303266100005],
          [120.22055127400006, 36.033034508000071],
          [120.22055120000005, 36.033034659000066],
          [120.22071397700006, 36.033088630000066],
          [120.22094992200005, 36.033011723000072],
          [120.22103018000007, 36.032965260000026],
          [120.22102698700007, 36.032963828000049],
          [120.22099610000009, 36.032945573000063],
          [120.22099694000008, 36.032940219000068],
          [120.22091513700002, 36.032898232000036],
          [120.22074405800004, 36.032810419000043],
          [120.22072575100003, 36.032833551000067],
          [120.22068059000003, 36.032809832000055],
          [120.2206725960001, 36.032818646000067]
        ],
        [
          [120.22047604800002, 36.033121314000027],
          [120.22047514700012, 36.03312171500005],
          [120.22047257300005, 36.033122036000066],
          [120.22047003800003, 36.033121515000062],
          [120.22046856100008, 36.033120688000054],
          [120.22046731400008, 36.033119526000064],
          [120.22046682100006, 36.033118745000024],
          [120.22046632900003, 36.033116813000049],
          [120.22046671600003, 36.03311491200003],
          [120.22046815700003, 36.033113028000059],
          [120.22047036700008, 36.033111801000075],
          [120.22047337300012, 36.033111408000025],
          [120.22047628000007, 36.033112163000055],
          [120.22047785900008, 36.033113251000032],
          [120.22047888400004, 36.033114573000034],
          [120.22047934200009, 36.033115806000069],
          [120.22047932300006, 36.03311771500006],
          [120.22047842500001, 36.033119563000071],
          [120.22047684000006, 36.033120963000044],
          [120.22047604800002, 36.033121314000027]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 814,
      "bh": "0302",
      "mc": "煤6号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.021017324697376921,
      "shape_Area": 4.4077104166935784e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21111123600008, 36.029538784000067],
          [120.21114393500011, 36.029558293000036],
          [120.21115785800009, 36.029566601000056],
          [120.21119346400008, 36.029587844000048],
          [120.21194939600002, 36.02998771700004],
          [120.21219884000004, 36.03011740200003],
          [120.2127250960001, 36.030387574000031],
          [120.21338405500001, 36.030725333000078],
          [120.21399935000011, 36.031042441000068],
          [120.21404060500004, 36.031064217000051],
          [120.21420918600006, 36.031162536000068],
          [120.21442275700008, 36.031290567000042],
          [120.21492548000003, 36.031617209000046],
          [120.21496221300004, 36.031643207000059],
          [120.21504112800005, 36.031686114000024],
          [120.21546116700006, 36.031903429000067],
          [120.21567764700001, 36.032012226000063],
          [120.21609552300004, 36.032228021000037],
          [120.21622044000003, 36.032295598000076],
          [120.21642909600007, 36.032401485000037],
          [120.21734396000011, 36.032875477000061],
          [120.21795385700011, 36.033190901000069],
          [120.21814075000009, 36.033289191000051],
          [120.21821623000005, 36.033321578000027],
          [120.21834860800004, 36.033367398000053],
          [120.21840708000002, 36.033387584000025],
          [120.21842174800008, 36.033391431000041],
          [120.21852948500009, 36.033429057000035],
          [120.21871085800001, 36.033492398000078],
          [120.21875668400003, 36.033508186000063],
          [120.21908650900002, 36.033621580000045],
          [120.21921780700006, 36.033666801000038],
          [120.21947714200007, 36.033723880000025],
          [120.21991381800001, 36.033820354000056],
          [120.21996673600006, 36.033813976000033],
          [120.21999468100012, 36.033807095000043],
          [120.22000205400002, 36.03380416300007],
          [120.21999872300012, 36.033803083000066],
          [120.22000673000002, 36.033798104000027],
          [120.2200343720001, 36.033774931000039],
          [120.22007177900002, 36.033726113000057],
          [120.22001361300011, 36.033696374000044],
          [120.21977258200002, 36.033573139000055],
          [120.21978443500007, 36.033556111000053],
          [120.21976951000011, 36.033548744000029],
          [120.21972446100006, 36.033527054000047],
          [120.21971693600005, 36.033537348000038],
          [120.2115262530001, 36.02930622100007],
          [120.21153185700007, 36.029294510000057],
          [120.21142291500007, 36.029237331000047],
          [120.21143715200003, 36.029219491000049],
          [120.21143972300001, 36.02921604800008],
          [120.21142078000003, 36.029206712000075],
          [120.21140314800004, 36.029229642000075],
          [120.21136793200003, 36.029211776000068],
          [120.21137602200008, 36.029201254000043],
          [120.21138186700011, 36.029193650000025],
          [120.21138527800008, 36.029189216000077],
          [120.21132644300008, 36.029160221000041],
          [120.21131825300006, 36.02917065500003],
          [120.21131196800002, 36.029178493000074],
          [120.21130793700002, 36.029183411000076],
          [120.21129793000011, 36.029177999000069],
          [120.21125884900005, 36.029156864000072],
          [120.21119042200007, 36.029119856000079],
          [120.21119929200006, 36.029109036000079],
          [120.21120714800008, 36.029099027000029],
          [120.21114493800007, 36.029066096000065],
          [120.21113969600003, 36.029072724000059],
          [120.21106304400007, 36.029032716000074],
          [120.21105191800007, 36.029027623000047],
          [120.21105005100003, 36.029031099000065],
          [120.21104172700007, 36.029046607000055],
          [120.21104052100009, 36.029046614000038],
          [120.21103778000008, 36.029047720000051],
          [120.21103671100002, 36.029048694000039],
          [120.21103613000002, 36.029049557000064],
          [120.2110356390001, 36.029051426000024],
          [120.21099907100006, 36.02912118200004],
          [120.21099632900007, 36.029122288000053],
          [120.21099525900001, 36.029123260000063],
          [120.21099467800002, 36.029124125000067],
          [120.21099418800009, 36.029125994000026],
          [120.21099444000004, 36.029127507000055],
          [120.21099532000005, 36.029128981000042],
          [120.21099614100001, 36.029129609000051],
          [120.21093883100002, 36.029229842000063],
          [120.21095133000006, 36.029394348000039],
          [120.2109934990001, 36.029463612000029],
          [120.21099685900003, 36.029466091000074],
          [120.21100963800006, 36.029475515000058],
          [120.21102846500003, 36.029489400000045],
          [120.21104614100011, 36.029499946000044],
          [120.21111123600008, 36.029538784000067]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 815,
      "bh": "0302",
      "mc": "67,68码头前沿",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0097339793760590938,
      "shape_Area": 1.7451510942722369e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22226925300004, 36.026778117000049],
          [120.22250918500004, 36.026558082000065],
          [120.22250912900006, 36.026558054000077],
          [120.2211673490001, 36.025669546000074],
          [120.22115226000005, 36.025659626000049],
          [120.22083607000002, 36.025451059000034],
          [120.22082255700002, 36.02544234700008],
          [120.22069656700012, 36.025357436000036],
          [120.22068366800011, 36.025348872000052],
          [120.22036952700012, 36.025141676000032],
          [120.22033991000001, 36.025120980000054],
          [120.21984620300009, 36.024794010000051],
          [120.21981838200008, 36.024777525000047],
          [120.21931331500002, 36.02444304800008],
          [120.21929542900011, 36.02443168800005],
          [120.21900217300004, 36.024240461000034],
          [120.21889038800009, 36.024170930000025],
          [120.21886200200004, 36.024151464000056],
          [120.21881750500006, 36.02412213000008],
          [120.21880375000001, 36.024113233000037],
          [120.21879519200002, 36.024122958000078],
          [120.21879505400011, 36.024128110000049],
          [120.21878497500006, 36.024128024000049],
          [120.21877931300003, 36.024127027000077],
          [120.21876985300003, 36.024125950000041],
          [120.21876454900007, 36.024125430000026],
          [120.21875708400012, 36.024123216000078],
          [120.21875146900004, 36.024120511000035],
          [120.21874600800004, 36.024116559000049],
          [120.21874180700001, 36.024113667000051],
          [120.21868041300002, 36.024104033000071],
          [120.21862646900001, 36.024096349000047],
          [120.21859631300003, 36.024157862000038],
          [120.21857492800007, 36.024200687000075],
          [120.21851903200002, 36.024312614000053],
          [120.21876254600011, 36.024549482000054],
          [120.21934654500001, 36.024938341000052],
          [120.22045786700005, 36.025678301000028],
          [120.22131088000003, 36.026224369000033],
          [120.22209698000006, 36.026727588000028],
          [120.22215248000009, 36.026763116000041],
          [120.22223361800002, 36.026815055000043],
          [120.22226925300004, 36.026778117000049]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 816,
      "bh": "0302",
      "mc": "煤3号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.021494587170088886,
      "shape_Area": 4.1405634355340316e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22073998200005, 36.03273118900006],
          [120.22078003600006, 36.032750829000065],
          [120.22076334200005, 36.032772287000057],
          [120.22101704300007, 36.032902507000074],
          [120.2210264150001, 36.032907318000071],
          [120.22102903300004, 36.03290439400007],
          [120.22107491800011, 36.032932655000025],
          [120.2210811870001, 36.032935734000034],
          [120.22108239400006, 36.032935031000079],
          [120.22113510700001, 36.032881964000069],
          [120.22113397100009, 36.032882105000056],
          [120.22113143700005, 36.032881584000052],
          [120.22112995900011, 36.032880757000044],
          [120.22112871200011, 36.032879595000054],
          [120.22112822000008, 36.032878814000071],
          [120.22112772700007, 36.032876882000039],
          [120.22112811400007, 36.032874981000077],
          [120.22112955600005, 36.032873097000049],
          [120.22113176500011, 36.032871870000065],
          [120.22113477000005, 36.032871477000072],
          [120.22113767700012, 36.032872232000045],
          [120.22113925700012, 36.032873320000078],
          [120.22114028100009, 36.032874642000024],
          [120.22124609500008, 36.032775496000056],
          [120.22124355900007, 36.032774974000063],
          [120.22124208100001, 36.032774147000055],
          [120.22124083600011, 36.032772985000065],
          [120.22124034300009, 36.032772205000072],
          [120.22123985000007, 36.03277027200005],
          [120.22124023800006, 36.032768371000031],
          [120.22124167800007, 36.03276648800005],
          [120.22124388700001, 36.032765261000065],
          [120.22124689400005, 36.032764867000026],
          [120.22124980100011, 36.032765623000046],
          [120.22125138100012, 36.032766710000033],
          [120.22125241900005, 36.032768070000031],
          [120.22141443200007, 36.032609189000027],
          [120.22146251900006, 36.032581511000046],
          [120.22146648900002, 36.032579087000045],
          [120.2210793480001, 36.03237828500005],
          [120.22105503200009, 36.032408143000055],
          [120.22101863400007, 36.03238863100006],
          [120.2210056450001, 36.03239310500004],
          [120.22078863900003, 36.032283518000042],
          [120.21740630400006, 36.030537365000043],
          [120.21597718800001, 36.029799522000076],
          [120.21258067500003, 36.028040922000059],
          [120.21258596600001, 36.028032126000028],
          [120.21249435300001, 36.02798430100006],
          [120.21251714900006, 36.02795658000008],
          [120.21242892400005, 36.02791103900006],
          [120.21212011200009, 36.028306654000062],
          [120.21215493600005, 36.028324793000024],
          [120.21215757100003, 36.028321455000025],
          [120.21216889600009, 36.028304773000059],
          [120.21226632000003, 36.02835549200006],
          [120.21227753700009, 36.028342691000034],
          [120.2123035730001, 36.02835424400007],
          [120.21715453200011, 36.030862108000065],
          [120.22073134800007, 36.032711033000055],
          [120.22074791000011, 36.032719413000052],
          [120.22073998200005, 36.03273118900006]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 817,
      "bh": "0302",
      "mc": "10万1号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0090013275784807962,
      "shape_Area": 1.2867626755761693e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22253982900008, 36.026574344000039],
          [120.2225173810001, 36.02655958500003],
          [120.22251547700012, 36.026559789000032],
          [120.22251349900012, 36.026559673000065],
          [120.22251130900008, 36.026559133000035],
          [120.22250918500004, 36.026558082000065],
          [120.22226925300004, 36.026778117000049],
          [120.22227521100001, 36.026782083000057],
          [120.22229306100007, 36.026783284000032],
          [120.22230856600004, 36.026785669000049],
          [120.22232049400009, 36.02678968400005],
          [120.22233109300009, 36.026795031000063],
          [120.22234137300006, 36.02680422800006],
          [120.22234824000009, 36.026811761000033],
          [120.22235193000006, 36.02682216200003],
          [120.22235077100004, 36.026831075000075],
          [120.22234778900008, 36.026837555000043],
          [120.22230719600009, 36.026876476000041],
          [120.22229363200006, 36.026889992000065],
          [120.22234595400005, 36.026924433000033],
          [120.22248482600003, 36.02701584700003],
          [120.2224924950001, 36.027007924000031],
          [120.22250697700008, 36.027017173000047],
          [120.22251985600008, 36.027002989000039],
          [120.2225229610001, 36.026999558000057],
          [120.22252855600004, 36.026992763000067],
          [120.22366118400009, 36.02773901200004],
          [120.22406109200006, 36.028003901000034],
          [120.22564937900006, 36.029055912000047],
          [120.22565718800001, 36.02904813400005],
          [120.22569145300008, 36.029010388000074],
          [120.22584809600005, 36.028854677000027],
          [120.22509397800002, 36.028354122000053],
          [120.22432553700003, 36.027843903000075],
          [120.22431336600005, 36.02785583900004],
          [120.22426504300006, 36.027823092000062],
          [120.22427686100002, 36.027811584000062],
          [120.22411447600007, 36.027703763000034],
          [120.22413618200005, 36.027681717000064],
          [120.22416392700006, 36.027652617000058],
          [120.22253982900008, 36.026574344000039]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 818,
      "bh": "0302",
      "mc": "小港池4号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.013324858372685518,
      "shape_Area": 2.946524072087461e-6
    },
    "geometry": {
      "rings": [
        [
          [120.22526199300012, 36.036374257000034],
          [120.22525516300004, 36.036377903000073],
          [120.22525644500001, 36.036377609000056],
          [120.22525790800012, 36.036377461000029],
          [120.22525922400007, 36.036377523000056],
          [120.22526055200001, 36.036377729000037],
          [120.22526187300002, 36.036378270000057],
          [120.22526332400003, 36.036379088000047],
          [120.22526437700003, 36.03638015000007],
          [120.2252650150001, 36.036381075000065],
          [120.22526553900002, 36.036382394000043],
          [120.22526568600006, 36.03638363400006],
          [120.2252651550001, 36.03638587100005],
          [120.22526415600009, 36.036387323000042],
          [120.22526243800007, 36.036388662000036],
          [120.22525994700004, 36.036389580000048],
          [120.22525733200007, 36.036389731000043],
          [120.22525453200001, 36.036389037000049],
          [120.22525288500003, 36.036388072000079],
          [120.22525148200009, 36.036386614000037],
          [120.22525055300002, 36.036384940000062],
          [120.2252503630001, 36.036383694000051],
          [120.22525062800003, 36.036382589000027],
          [120.22525100200005, 36.036381474000052],
          [120.22525173800011, 36.03638027900007],
          [120.22525262600004, 36.036379256000032],
          [120.22524630100008, 36.036382631000038],
          [120.22525068700008, 36.036388595000062],
          [120.22536691700009, 36.036537130000056],
          [120.22537335300001, 36.036545216000036],
          [120.22537777500008, 36.036542949000079],
          [120.22537600400005, 36.03654305200007],
          [120.22537325300004, 36.036542370000063],
          [120.22537164300002, 36.036541427000031],
          [120.22537026400005, 36.036539994000066],
          [120.22536935100004, 36.036538350000058],
          [120.22536916700005, 36.036537140000064],
          [120.22536942600004, 36.036536058000024],
          [120.22536979500001, 36.03653496000004],
          [120.22537051800009, 36.036533785000074],
          [120.2253714200001, 36.036532824000062],
          [120.22537276800006, 36.03653196700003],
          [120.22537388900002, 36.036531475000061],
          [120.22537513000009, 36.036531168000067],
          [120.22537656600002, 36.036531024000055],
          [120.2253778590001, 36.036531085000036],
          [120.22537915900011, 36.03653128600007],
          [120.22538045200008, 36.036531815000046],
          [120.22538187600003, 36.036532618000024],
          [120.22538290900002, 36.036533661000078],
          [120.22538353300001, 36.036534565000068],
          [120.22538404800002, 36.036535861000061],
          [120.2253841910001, 36.036537070000065],
          [120.22538366900005, 36.036539271000038],
          [120.22538296800008, 36.036540289000072],
          [120.22538757900008, 36.036537926000051],
          [120.22583396100003, 36.037115828000026],
          [120.22582076900005, 36.037122588000045],
          [120.22582716600004, 36.03713235400005],
          [120.22594303700009, 36.037286241000061],
          [120.2259542160001, 36.037298515000032],
          [120.22595502000001, 36.037299534000056],
          [120.22596989400006, 36.03729330200008],
          [120.2263619360001, 36.03780125600008],
          [120.22681177600009, 36.037572018000049],
          [120.22672799300005, 36.037468665000063],
          [120.2267069940001, 36.037439436000057],
          [120.22670070800007, 36.037431066000067],
          [120.22334383200007, 36.033106306000036],
          [120.22333793700011, 36.033098710000047],
          [120.22330113400005, 36.033051293000028],
          [120.22331536900003, 36.033044394000058],
          [120.22331985800008, 36.033042155000032],
          [120.22327127700009, 36.032982765000042],
          [120.22321732500006, 36.03292433200005],
          [120.22320557700004, 36.032929911000053],
          [120.22320231800006, 36.032931518000055],
          [120.22292760700009, 36.033058746000052],
          [120.22298992600008, 36.033863500000052],
          [120.22299083100006, 36.033875188000025],
          [120.22297469500006, 36.033875998000042],
          [120.22297363900009, 36.033864362000031],
          [120.22297688300011, 36.033904792000044],
          [120.22317470900009, 36.033901313000058],
          [120.22324228800005, 36.03390236000007],
          [120.22332623600005, 36.033900651000067],
          [120.22337241700006, 36.033961331000057],
          [120.22337469700005, 36.033960080000043],
          [120.22339081100006, 36.033951103000049],
          [120.22362757400003, 36.034256816000038],
          [120.22361043800004, 36.034265120000043],
          [120.22362407600008, 36.034282645000076],
          [120.22374723200005, 36.034441646000062],
          [120.22376466800006, 36.034433105000062],
          [120.2241261580001, 36.034902587000033],
          [120.22411198600003, 36.034910561000061],
          [120.22412064200012, 36.034921951000058],
          [120.22424229300009, 36.035075878000043],
          [120.22425342200006, 36.035091598000065],
          [120.22426884700008, 36.035083427000075],
          [120.22469744800003, 36.035640255000033],
          [120.22468131100004, 36.035648268000045],
          [120.22469501900002, 36.035666140000046],
          [120.2248436750001, 36.035860935000073],
          [120.22485926200011, 36.03585268300003],
          [120.22526199300012, 36.036374257000034]
        ],
        [
          [120.22469217100002, 36.035653961000037],
          [120.22469309700011, 36.035652975000062],
          [120.22469447500009, 36.035652098000071],
          [120.22469562500009, 36.035651593000068],
          [120.22469689900004, 36.035651279000035],
          [120.22469836700009, 36.035651130000076],
          [120.22469968700011, 36.035651193000035],
          [120.22470102300008, 36.035651400000063],
          [120.22470235000003, 36.035651943000062],
          [120.22470380600009, 36.035652764000076],
          [120.22470486400005, 36.035653831000047],
          [120.2247055040001, 36.035654760000057],
          [120.22470603000011, 36.035656085000028],
          [120.22470617800002, 36.035657330000049],
          [120.22470564500009, 36.035659575000068],
          [120.22470464200001, 36.035661034000043],
          [120.22470291600007, 36.035662380000076],
          [120.22470041500003, 36.035663302000046],
          [120.22469778800007, 36.035663453000041],
          [120.22469497800012, 36.035662757000068],
          [120.22469332300011, 36.035661787000038],
          [120.22469191500011, 36.035660324000048],
          [120.22469098300007, 36.035658643000033],
          [120.22469079000007, 36.03565738900005],
          [120.2246910560001, 36.035656278000033],
          [120.2246914320001, 36.035655161000079],
          [120.22469217100002, 36.035653961000037]
        ],
        [
          [120.22362301900012, 36.034264939000025],
          [120.22362546600004, 36.034264736000068],
          [120.22362770400002, 36.034265260000041],
          [120.2236296100001, 36.034266410000043],
          [120.2236307500001, 36.03426752200005],
          [120.22363121700005, 36.034269975000029],
          [120.22363130400004, 36.034271681000064],
          [120.22363039000004, 36.034273576000032],
          [120.22362934700004, 36.034274836000066],
          [120.22362753400012, 36.03427586600003],
          [120.2236249020001, 36.034276298000066],
          [120.22362271200006, 36.034276243000079],
          [120.22362055700012, 36.034275704000038],
          [120.22361890400009, 36.034274562000064],
          [120.22361757100009, 36.034273347000067],
          [120.22361693000005, 36.034271781000029],
          [120.22361691200001, 36.034270332000062],
          [120.22361715700004, 36.034268563000069],
          [120.22361859000011, 36.034266364000075],
          [120.22362035300011, 36.034265674000039],
          [120.22362301900012, 36.034264939000025]
        ],
        [
          [120.22424939300004, 36.035078100000078],
          [120.22425021600009, 36.035077225000066],
          [120.22425146700004, 36.035076429000071],
          [120.22425249300011, 36.035075978000066],
          [120.22425362900003, 36.035075698000071],
          [120.22425496400001, 36.035075564000067],
          [120.22425616600003, 36.035075620000043],
          [120.22425734700005, 36.035075803000041],
          [120.22425853100003, 36.035076287000038],
          [120.22425985100006, 36.03507703300005],
          [120.22426080100001, 36.035077991000037],
          [120.2242613730001, 36.035078820000024],
          [120.22426185000006, 36.035080022000045],
          [120.22426197900006, 36.035081111000068],
          [120.22426149100011, 36.035083170000064],
          [120.22426060200007, 36.035084462000043],
          [120.22425905200009, 36.035085670000058],
          [120.22425679700007, 36.03508650100008],
          [120.22425444700002, 36.035086637000063],
          [120.22425189300009, 36.03508600400005],
          [120.22425042800012, 36.035085146000029],
          [120.22424914400005, 36.03508381100005],
          [120.22424829800002, 36.035082285000044],
          [120.22424813500004, 36.035081221000041],
          [120.22424837200003, 36.035080230000062],
          [120.22424872000011, 36.035079194000048],
          [120.22424939300004, 36.035078100000078]
        ],
        [
          [120.22412146300007, 36.034906427000067],
          [120.22412376300008, 36.03490623600004],
          [120.22412582800007, 36.034906719000048],
          [120.22412761800001, 36.034907799000052],
          [120.22412863400007, 36.034908791000078],
          [120.22412907600005, 36.034911114000067],
          [120.2241291580001, 36.034912716000065],
          [120.22412830000007, 36.034914494000077],
          [120.22412733700003, 36.034915658000045],
          [120.22412568100003, 36.034916598000052],
          [120.2241232020001, 36.034917006000057],
          [120.22412113400003, 36.034916953000049],
          [120.22411913600001, 36.034916453000051],
          [120.22411758400006, 36.034915382000065],
          [120.22411634000002, 36.034914247000074],
          [120.22411575400008, 36.03491281600003],
          [120.22411573800002, 36.034911454000053],
          [120.22411596900008, 36.034909782000057],
          [120.22411728400004, 36.034907763000035],
          [120.22411887800001, 36.03490713900004],
          [120.22412146300007, 36.034906427000067]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 819,
      "bh": "0302",
      "mc": "20万7号堆场",
      "lx": "货区",
      "dmgd": 0,
      "ssgs_old": "前港",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "shape_Length": 0.0079609894300220162,
      "shape_Area": 2.4766704773069515e-6
    },
    "geometry": {
      "rings": [
        [
          [120.21243244700008, 36.027028061000067],
          [120.21250073400006, 36.027039734000027],
          [120.21338725800001, 36.026987792000057],
          [120.21386206900002, 36.026749598000038],
          [120.21388029900004, 36.026738375000036],
          [120.21392947200002, 36.026705915000036],
          [120.21417036900004, 36.026550974000031],
          [120.21460810700012, 36.026109102000078],
          [120.21482017200003, 36.02588121000008],
          [120.21476324900004, 36.025843850000058],
          [120.21451566600001, 36.025871107000057],
          [120.21409756700007, 36.025916706000032],
          [120.21409036400007, 36.025916275000043],
          [120.21388578800008, 36.025937619000047],
          [120.21386059700001, 36.025940299000069],
          [120.21377803400003, 36.025949661000027],
          [120.21356587200012, 36.02597376600005],
          [120.21332263800002, 36.026000709000073],
          [120.21321387000012, 36.02601326100006],
          [120.21300611700008, 36.026036006000027],
          [120.21294960700004, 36.026042582000059],
          [120.21242191200008, 36.026101101000052],
          [120.21228691200008, 36.026116484000056],
          [120.2120616410001, 36.026141455000072],
          [120.21187473400005, 36.026162441000054],
          [120.21164819900002, 36.026187425000046],
          [120.21144248300004, 36.026209792000031],
          [120.21128117300009, 36.026227578000032],
          [120.2112803660001, 36.026231600000074],
          [120.21127945600006, 36.026238216000024],
          [120.21123229600005, 36.026413167000044],
          [120.21122788900004, 36.026429518000043],
          [120.21148324700005, 36.026561530000038],
          [120.21164471800012, 36.02664444800007],
          [120.21167509600002, 36.026637332000064],
          [120.21196060300008, 36.026785027000074],
          [120.21196688500004, 36.026810883000053],
          [120.21232372300005, 36.026994307000052],
          [120.21233543200003, 36.027000021000049],
          [120.21235107200005, 36.026979495000035],
          [120.21240107200003, 36.027003757000045],
          [120.21241263800005, 36.027009023000062],
          [120.2124079780001, 36.027015775000052],
          [120.21243244700008, 36.027028061000067]
        ]
      ]
    }
  },
]
